import React, { Fragment, PureComponent } from 'react';
// import ReactDOM from "react-dom";
import { observer, inject } from 'mobx-react';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import themes, { overrides } from '../../themes';
import { Grid, withStyles, Tooltip, Fab, Menu, MenuItem, Button, AppBar } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import classnames from 'classnames';
import _ from 'lodash';

import deburr from 'lodash/deburr';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';

import socketIOClient from 'socket.io-client';
import { messaging } from '../../firebase';

import Loader from '../../components/Loader/LoaderView';
import CustomContentTemplate from './components/Alert/CustomContentTemplate';
import Widget from '../../components/Widget/WidgetContainer';
import { Typography } from '../../components/Wrappers/Wrappers';
import { notification } from 'antd';
import Map from './components/Maps';
import Setting from '../../components/Dialog/SettingView';
import Devices from '../../components/Dialog/DevicesView';
import Patient from '../../components/Dialog/PatientView';
import ContactPerson from '../../components/Dialog/ContactPersonView';
import Movement from '../../components/Dialog/MovementView';
import CreateAccount from '../../components/Dialog/CreateAccountView';
import StatusView from '../../components/Dialog/StatusView';
import ManageGarminAccount from '../../components/Dialog/ManageGarminAccountView';
import VitalSigns from '../../components/Dialog/VitalSignsView';
import 'font-awesome/css/font-awesome.min.css';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';
import iconGetUp from '../../images/Presense/Action/icon-stand.png';
import iconJump from '../../images/Presense/Action/icon-jump.png';
import iconNoMovement from '../../images/Presense/Action/icon-nomovement.png';
import iconNosignal from '../../images/Presense/DeviceSignal/icon-nosignal.png';
import config from '../../config';
import Sound from 'react-sound';
import soundCritical from '../../sound/presense/critical-alert.mp3';
import soundWarning from '../../sound/presense/warning-alert-new.mp3';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage, fullname } from '../../utils/common';
import { createMuiTheme } from '@material-ui/core/styles';
import ContentRow from './components/Table/ContentRow';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SummaryReportPage from '../summaryReport/SummaryReportPage';
import { getTimeFormatted, getCurrentDateBuddhistFormatted, fixedEmergencyDate } from '../../utils/timeFormatted';
import moment from 'moment';
import './style.css';

import {
  sortByAdmited,
  sortByPriorityOld,
  sortByPriorityNew,
  sortByRoom,
  sortListmanage,
  sortFixedEmergency,
} from './Sortting';
import { hasAlertType } from '../../utils/voteAlert';
import HeaderBar from './components/HeaderBar';

export class Dashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      soundEmergincy: false,
      isDisplayFixedEmergency: true,
      module: 0,
      group: 0,
      page: 0,
      gridPage: 2,
      list: 'listview',
      setList: null,
      anchorEl: null,
      // setSort: null,
      labelGroupWidth: 0,
      labelModuleWidth: 0,
      labelSortWidth: 0,
      sort: 'showAll',
      dialogStatus: {
        id: null,
        open: false,
      },
      dialogActivities: {
        id: null,
        open: false,
      },
      dialogSetting: {
        id: null,
        open: false,
      },
      dialogPatient: {
        id: null,
        open: false,
        bedInfo: null,
        tenantId: null,
      },
      dialogDevice: {
        id: null,
        open: false,
      },
      dialogContact: {
        id: null,
        open: false,
        readOnly: false,
      },
      dialogMovement: {
        id: null,
        open: false,
      },
      dialogCreateAccount: {
        id: null,
        open: false,
      },
      dialogGarminAccount: {
        id: null,
        open: false,
      },
      dialogVitalSigns: {
        id: null,
        open: false,
      },
      movement: {
        id: 0,
      },
      data: {
        search: false,
        name: '',
        patient: {
          hn: '',
          firstname: '',
          lastname: '',
          gender: 'M',
          dob: '0000-00-00',
        },
      },
      searchHN: '',
      suggestions: [],
      setTooltipTitle: '',
      setTooltipOpen: false,
      isMoreMenuOpen: null,
      patientData: '',
      seeFunc: {
        seeOrganization: false,
        seeGroup: false,
        seeFilter: false,
        seeSort: false,
        seeGrid: false,
        seeList: false,
        seeMap: false,
      },
      table: {
        seeBoxColor: false,
        seeHN: false,
        seeName: false,
        seeRoom: false,
        seeAction: false,
        seeStatus: false,
        seeAlert: false,
        seeAlertTime: false,
        seeOption: false,
      },
    };
    this.socket = null;
    this.handleTenantChanged = this.handleTenantChanged.bind(this);
  }

  renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);
    return (
      <MenuItem selected={isHighlighted} component='div'>
        <div>
          {parts.map((part, index) =>
            part.highlight ? (
              <span key={String(index)} style={{ fontWeight: 500 }}>
                {part.text}
              </span>
            ) : (
              <strong key={String(index)} style={{ fontWeight: 300 }}>
                {part.text}
              </strong>
            ),
          )}
        </div>
      </MenuItem>
    );
  }

  renderInputComponent(inputProps) {
    const { classes, inputRef = () => {}, ref, ...other } = inputProps;
    return (
      <TextField
        variant='outlined'
        fullWidth
        InputProps={{
          inputRef: (node) => {
            ref(node);
            inputRef(node);
          },
          classes: {
            input: classes.input,
          },
        }}
        {...other}
      />
    );
  }

  getSuggestionValue(suggestion) {
    return suggestion.label;
  }

  getSuggestions(value) {
    let { hnList } = this.props.dashboard.toJS();
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    return inputLength === 0
      ? []
      : hnList.filter((hnList) => {
          const keep = count < 30 && hnList.label && hnList.label.slice(0, inputLength).toLowerCase() === inputValue;
          if (keep) {
            count += 1;
          }
          return keep;
        });
  }

  async handleTenantChanged() {
    this.props.dashboard.resetFixedEmergencyAlarm();

    const host = window.location.hostname;
    if (host.includes('dip.airpresense.tech')) {
      localStorage.setItem('select_group', 3);
      localStorage.setItem('select_module', JSON.stringify([39]));
    }

    const isSuperAdmin = localStorage.getItem('role_id') === '1';
    const tenantPermission = +localStorage.getItem('select_tenant');
    this.props.group.resetGroups();
    if (!isSuperAdmin) {
      //in the future, should implement get group by Grouppermission and tenantId
      // let locationPermission = localStorage.getItem("location_permission");
      // locationPermission =
      //   locationPermission !== "undefined"
      //     ? JSON.parse(locationPermission)
      //     : [];
      // if (locationPermission.length > 0) {
      //   await this.props.group.getGroupListByLocationIds(locationPermission, [tenantPermission]);
      // }
      if (tenantPermission) {
        await this.props.group.getGroupList([tenantPermission]);
      }
    } else {
      //get group by tenantId
      if (tenantPermission) {
        await this.props.group.getGroupList([tenantPermission]);
      }
    }

    const { groups } = this.props.group.toJS();
    if (groups.length === 1) {
      localStorage.setItem('select_group', groups[0].id);
      localStorage.removeItem('select_module');
      this.setState({
        group: groups[0].id,
        module: 0,
      });
    } else {
      localStorage.removeItem('select_group');
      localStorage.removeItem('select_module');
      this.props.subGroup.setSubGroup([]);
      this.setState({
        group: 0,
        module: 0,
      });
    }

    const subGroupPermission = JSON.parse(localStorage.getItem('subgroup_permission'));

    if (localStorage.getItem('select_group')) {
      // handlegroup dropdown
      this.setState({
        group: +localStorage.getItem('select_group'),
        module: 0,
      });
      const groupSelect = (groups || []).find((val) => +val.id === +localStorage.getItem('select_group'));

      // if (groupSelect) {
      //   const subGroups = (groupSelect.subGroups || []).filter(val =>
      //     isSuperAdmin || subGroupPermission.includes(val.id)
      //   );
      //   this.props.subGroup.setSubGroup(subGroups);
      // }
      if (groupSelect) {
        const allSubgroupIds = groupSelect.subGroups.map((s) => s.id);
        const diff = allSubgroupIds.filter((id) => !subGroupPermission.includes(id));
        const subGroups = (groupSelect.subGroups || []).filter(
          (val) => isSuperAdmin || diff.length === allSubgroupIds.length || subGroupPermission.includes(val.id),
        );
        this.props.subGroup.setSubGroup(subGroups);
      }
      await this.initMap(localStorage.getItem('select_group'));
    } else {
      await this.props.maps.clearMap();
      await this.props.dashboard.resetRouterNoSignal();
    }

    // const { ListSubGroups } = this.props.subGroup.toJS();
    // if (!localStorage.getItem("select_module") && (isSuperAdmin || subGroupPermission.length > 1)) {
    //   // set select all module
    //   localStorage.setItem("select_module", JSON.stringify(ListSubGroups.map(s => s.id)));
    // }

    const { ListSubGroups } = this.props.subGroup.toJS();
    if (localStorage.getItem('select_group') && !localStorage.getItem('select_module')) {
      localStorage.setItem('select_module', JSON.stringify(ListSubGroups.map((s) => s.id)));
    }

    if (localStorage.getItem('select_module')) {
      await this.initBedNoLoading(localStorage.getItem('select_module'));
      this.setState({ module: localStorage.getItem('select_module') });
      localStorage.setItem(
        'subgroup_type',
        ListSubGroups && ListSubGroups.length > 0 && ListSubGroups[0].type ? ListSubGroups[0].type : 'hospital',
      );

      // await this.initBedNoLoading(localStorage.getItem("select_module"));
      this.initRouter(localStorage.getItem('select_module'));
      // unsubscribe fcm
      await this.unSubscribeToServer();
      this.subscribeToServer();
      this.props.patient.findMapBySubgroupIds(localStorage.getItem('select_module'));
      setTimeout(() => {
        this.actionChanges();
      }, 0);
    }

    this.getLastFixedEmergencyAlarm();
    await this.props.acknowledge.getAcknowledge();
  }

  async componentDidMount() {
    document.addEventListener('TenantChanged', this.handleTenantChanged);
    this.props.dashboard.resetFixedEmergencyAlarm();
    this.handleViewPage();
    this.props.dashboard.updateToken();
    await this.props.area.getAreas();
    this.setState({ sort: localStorage.getItem('sort') || 'showAll' });
    await this.props.router.getRouters();

    const host = window.location.hostname;
    if (host.includes('dip.airpresense.tech')) {
      localStorage.setItem('select_group', 3);
      localStorage.setItem('select_module', JSON.stringify([39]));
    }

    const isSuperAdmin = localStorage.getItem('role_id') === '1';
    const tenantPermission = +localStorage.getItem('select_tenant');
    const groupPermission = localStorage.getItem('group_permission')
      ? JSON.parse(localStorage.getItem('group_permission'))
      : null;
    this.props.group.resetGroups();

    if (!isSuperAdmin) {
      //in the future, should implement get group by Grouppermission and tenantId
      if (tenantPermission) {
        await this.props.group.getGroupListByPermission([tenantPermission], groupPermission);
      }
    } else {
      //get group by tenantId
      if (tenantPermission) {
        await this.props.group.getGroupList([tenantPermission]);
      }
    }

    const { groups } = this.props.group.toJS();
    if (!localStorage.getItem('select_group')) {
      if (groups.length === 1) {
        localStorage.setItem('select_group', groups[0].id);
        localStorage.removeItem('select_module');
      } else {
        localStorage.removeItem('select_group');
        localStorage.removeItem('select_module');
        this.props.subGroup.setSubGroup([]);
        this.setState({
          group: 0,
          module: 0,
        });
      }
    }

    const subGroupPermission = JSON.parse(localStorage.getItem('subgroup_permission'));

    if (localStorage.getItem('select_group')) {
      // handlegroup dropdown
      this.setState({
        group: +localStorage.getItem('select_group'),
        module: 0,
      });
      const groupSelect = (groups || []).find((val) => +val.id === +localStorage.getItem('select_group'));
      if (groupSelect) {
        const allSubgroupIds = groupSelect.subGroups.map((s) => s.id);
        const diff = allSubgroupIds.filter((id) => !subGroupPermission.includes(id));
        const subGroups = (groupSelect.subGroups || []).filter(
          (val) => isSuperAdmin || diff.length === allSubgroupIds.length || subGroupPermission.includes(val.id),
        );
        this.props.subGroup.setSubGroup(subGroups);
      }
      await this.initMap(localStorage.getItem('select_group'));
    } else {
      await this.props.maps.clearMap();
      await this.props.dashboard.resetRouterNoSignal();
    }

    const { ListSubGroups } = this.props.subGroup.toJS();
    if (localStorage.getItem('select_group') && !localStorage.getItem('select_module')) {
      localStorage.setItem('select_module', JSON.stringify(ListSubGroups.map((s) => s.id)));
    }

    if (localStorage.getItem('select_module')) {
      this.initRouter(localStorage.getItem('select_module'));
      await this.initBedNoLoading(localStorage.getItem('select_module'));
      this.setState({ module: localStorage.getItem('select_module') });
      localStorage.setItem(
        'subgroup_type',
        ListSubGroups && ListSubGroups.length > 0 && ListSubGroups[0].type ? ListSubGroups[0].type : 'hospital',
      );

      // await this.initBedNoLoading(localStorage.getItem("select_module"));
      // this.initRouter(localStorage.getItem("select_module"));
      // unsubscribe fcm
      await this.unSubscribeToServer();
      this.subscribeToServer();
      this.props.patient.findMapBySubgroupIds(localStorage.getItem('select_module'));

      setTimeout(() => {
        this.actionChanges();
      }, 0);
    }

    this.getLastFixedEmergencyAlarm();
    await this.props.acknowledge.getAcknowledge();
  }

  async handleViewPage() {
    if (localStorage.getItem('role') === 'Technician') {
      localStorage.setItem('last_view', 'map');
      this.setState({
        seeFunc: {
          seeOrganization: true,
          seeGroup: true,
          seeFilter: false,
          seeSort: false,
          seeGrid: false,
          seeList: false,
          seeMap: true,
        },
        page: 2,
        list: 'map',
      });
    } else {
      this.setState({
        seeFunc: {
          seeOrganization: true,
          seeGroup: true,
          seeFilter: true,
          seeSort: true,
          seeGrid: true,
          seeList: true,
          seeMap: true,
        },
        table: {
          seeBoxColor: true,
          seeHN: true,
          seeName: true,
          seeRoom: true,
          seeAction: false,
          seeStatus: true,
          seeAlert: true,
          seeAlertTime: true,
          seeOption: true,
        },
      });
      this.getLastView();
    }
  }

  getLastView() {
    const lastView = localStorage.getItem('last_view') || 'listview';
    if (lastView === '4') {
      this.setState({ page: 0, gridPage: 3 });
    } else if (lastView === '6') {
      this.setState({ page: 0, gridPage: 2 });
    } else if (lastView === 'listview') {
      let sortData = localStorage.getItem('sort');
      if (!localStorage.getItem('sort')) {
        localStorage.setItem('sort', 'priority-new');
      } else {
        localStorage.setItem('sort', sortData);
      }
      this.setState({
        page: 1,
        list: 'listview',
        sort: localStorage.getItem('sort'),
      });
    } else if (lastView === 'listmanage') {
      this.setState({ page: 1, list: 'listmanage' });
    } else if (lastView === 'map') {
      this.setState({ page: 2, list: 'map' });
    }
  }

  getLastFixedEmergencyAlarm() {
    const subgroupIds = this.getSubgroupIds();
    this.props.dashboard.getLastFixedEmergencyAlarm(subgroupIds);
  }

  getSubgroupIds() {
    let subgroupIds = [];

    const subGroupPermission = localStorage.getItem('subgroup_permission')
      ? JSON.parse(localStorage.getItem('subgroup_permission'))
      : null;

    const { groups } = this.props.group.toJS();
    if (subGroupPermission) {
      for (const group of groups) {
        if (group.subGroups.length > 0) {
          // has subgroup permission
          const subGroups = (group.subGroups || []).filter((val) => subGroupPermission.includes(val.id));
          if (subGroups.length > 0) {
            (subGroups || []).forEach((s) => {
              subgroupIds.push(s.id);
            });
          } else {
            (group.subGroups || []).forEach((s) => {
              subgroupIds.push(s.id);
            });
          }
        }
      }
    }

    return subgroupIds;
  }
  // async initData() {
  //   const { groups } = this.props.group.toJS();
  //   let groupPermission = localStorage.getItem("group_permission");
  //   groupPermission = JSON.parse(groupPermission);
  //   let subGroupPermission = localStorage.getItem("subgroup_permission");
  //   subGroupPermission = JSON.parse(subGroupPermission);
  //   if (groupPermission.length === 1) {
  //     groupPermission.forEach((data) => {
  //       localStorage.setItem("select_group", data);
  //       const group = groups.find((item) => item.id === data);
  //       if (group) {
  //         if (subGroupPermission.length === 1 || group.subGroups.length === 1) {
  //           const subGroup = group.subGroups.find(
  //             (sub) => sub.id === subGroupPermission[0]
  //           );
  //           if (subGroup) {
  //             localStorage.setItem(
  //               "select_module",
  //               JSON.stringify([subGroupPermission[0]])
  //             );
  //             localStorage.setItem(
  //               "subgroup_type",
  //               subGroup.type || "hospital"
  //             );
  //           }
  //         }
  //       } else {
  //         this.signOut();
  //         window.location.replace("/login");
  //       }
  //     });
  //   }
  // }

  async initMap(groupId) {
    await this.props.router.clearRouterMap();
    await this.props.maps.clearMap();
    await this.props.dashboard.resetRouterNoSignal();

    let mapGroup = [];
    let { groups } = this.props.group.toJS();
    let groupSelect = (groups || []).find((val) => +val.id === +groupId);
    if (groupSelect && groupSelect.name !== 'Home' && groupSelect.subGroups.length > 0) {
      let subgroups = groupSelect.subGroups;
      // await this.props.dashboard.resetRouterNoSignal();
      if (localStorage.getItem('role_id') !== '1') {
        const subGroupPermission = JSON.parse(localStorage.getItem('subgroup_permission'));
        if (subGroupPermission.length > 0) {
          subgroups = (groupSelect.subGroups || []).filter((val) => subGroupPermission.includes(val.id));
        }
      }
      for (const data of subgroups) {
        if (data.map) {
          // mapIds.push(data.map.id);
          const maps = await this.props.maps._getMapById(data.map.id);
          mapGroup.push(maps);
        } else {
          // await this.props.router.clearRouterMap();
          // await this.props.maps.clearMap();
        }
      }
      await this.props.maps.setMaps(mapGroup);
    }
  }

  async initRouter(subGroupIds) {
    if (subGroupIds) {
      let subGroups = JSON.parse(subGroupIds);
      const subGroup = this.props.subGroup.toJS();
      if (subGroups.length > 0) {
        // await this.props.router.getRouters();
        await this.props.dashboard.resetRouterNoSignal();
        let subGroupSelect = null;
        if (subGroups.length === 1) {
          for (const data of subGroups) {
            subGroupSelect = subGroup.ListSubGroups.find((val) => +val.id === +data);
          }
          if (localStorage.getItem('role_id') === '1') {
            // this.setFilterLog(2);
          }
        }
        // find map
        if (subGroupSelect && subGroupSelect.map) {
          this.props.maps.setMapById(subGroupSelect.mapId);
        } else {
          this.props.maps.setMapById(-1);
        }

        let { mapData } = this.props.maps.toJS();
        const mapIds = (mapData || []).map((m) => m.id);
        if (mapIds.length > 0) {
          // find router in map
          const routerMap = await this.props.router.getRouterInMaps(mapIds);
          const alertedRouters = routerMap.filter(
            (val) => !val.routerConnection || val.routerConnection.status === 'DISCONNECTED',
          );
          if (alertedRouters.length > 0) {
            const formatedData = alertedRouters.map((val) => {
              return val.serial;
            });
            this.props.dashboard.setAlertRouter(formatedData, 'alertDb');
          }

          // find fixed emergency device in map
          const tenantPermission = +localStorage.getItem('select_tenant');
          const queryOption = {
            tenantIds: JSON.stringify([tenantPermission]),
            filterOutStatus: [],
            requiredMapIdNull: false,
            mapIds: JSON.stringify(mapIds),
          };
          await this.props.device.getFixedEmergencyDevices(queryOption);
        }
      }
    }
  }

  async initBed(subGroupId) {
    await this.props.dashboard.getPatientForSubgroup(subGroupId);
  }

  async initBedNoLoading(subGroupId) {
    await this.props.dashboard.getPatientForSubgroup(subGroupId, false);
  }

  async setDataChangeList(payloadList, task) {
    // const t0 = performance.now()
    const { routerNoSignal } = this.props.dashboard.toJS();
    (payloadList || []).forEach((data) => {
      const payloads = task === 'init' ? data : data.data;
      (payloads.notifications || []).forEach((payload) => {
        // checking for router nosignal status
        if (payload.routerSerial && payload.deviceSerial === '') {
          if (payload.alerts && payload.alerts.length > 0) {
            payload.alerts.forEach((a) => {
              if (a.alertType === 505 && a.alertWarning === 'true') {
                let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
                if (!router) {
                  this.props.dashboard.setAlertRouter(payload.routerSerial, 'alertDb');
                }
              } else {
                let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
                if (router) {
                  this.props.dashboard.resetAlertRouter(payload.routerSerial);
                }
              }
            });
          }
          // if (payload.alertInfo === "No Signal") {
          //   let router = routerNoSignal.find(
          //     (val) => val.routerId === payload.routerSerial
          //   );
          //   if (!router) {
          //     this.props.dashboard.setAlertRouter(
          //       payload.routerSerial,
          //       "alertDb"
          //     );
          //   }
          // } else {
          //   let router = routerNoSignal.find(
          //     (val) => val.routerId === payload.routerSerial
          //   );
          //   if (router) {
          //     this.props.dashboard.resetAlertRouter(payload.routerSerial);
          //   }
          // }
        } else if (
          payload.deviceSerial.length > 0 &&
          !payload.patientId &&
          payload.alerts &&
          payload.alerts.length > 0 &&
          payload.alerts[0].alertType === 514
        ) {
          // checking for fixed emergency
          this.setState({ isDisplayFixedEmergency: true });
          this.props.dashboard.setPayloadFixedEmegencyAlarm(payload);

          // payload.alerts.forEach((a) => {
          //   if (!payload.patientId && a.alertType === 514) {
          //     this.setState({ isDisplayFixedEmergency: true});
          //     this.props.dashboard.setPayloadFixedEmegencyAlarm(payload);
          //   }
          // });
          // payload.alerts.forEach((a) => {
          //   if (!payload.patientId && a.alertType === 514) {
          //     this.setState({ soundEmergincy: true });
          //     Alert.success("Header", {
          //       customFields: {
          //         type: "critical",
          //         alertType: 514,
          //         alertTime: a.alertTime,
          //         alertFixedEmergencyPlace: a.alertFixedEmergencyPlace,
          //         handleCloseSound: this.handleCloseSound,
          //       },
          //       position: "top-right",
          //       timeout: "none",
          //     });
          //   }
          // });
        }

        // if (
        //   !payload.subGroupId &&
        //   payload.alertType &&
        //   payload.alertType === 514
        // ) {
        //   if (payload.alertCritical === "true") {
        //     Alert.success("Header", {
        //       customFields: {
        //         type: "critical",
        //         alertType: 514,
        //       },
        //       position: "top-right",
        //       timeout: "none",
        //     });
        //   }
        // }

        // logs activity
        // if (payload.changed) {
        //   // set change
        //   const changed = JSON.parse(payload.changed);
        //   if (
        //     (changed.a && this.validateChange("a", changed.a)) ||
        //     (changed.f !== null &&
        //       changed.f !== "" &&
        //       changed.f !== undefined &&
        //       this.validateChange("f", changed.f)) ||
        //     changed.b
        //     // || (changed.m && payload.alertWarning === 'true' && !changed.a)
        //   ) {
        //     if (localStorage.getItem("role_id") === "1" && task === "realtime") {
        //       // set logs activity
        //       if (
        //         (changed.f && changed.f === 3) ||
        //         changed.a ||
        //         (changed.b < 20 && payload.alertWarning === "true")
        //       ) {
        //         const patient = this.props.dashboard.getAlertID(
        //           payload.deviceSerial
        //         );
        //         let activity = changed.f === 3 ? 12 : changed.a;
        //         if (changed.b < 20 && payload.alertWarning === "true") {
        //           activity = 8;
        //         }
        //         if (payload.deviceSerial && patient) {
        //           const dataLogActivity = {
        //             id: Math.floor((Math.random() * 10000000) + 1),
        //             variant: payload.alertCritical === 'true' ? 'error' : payload.alertWarning === 'true' ? 'warning' : 'primary',
        //             time: moment().format(),
        //             action: this.getMomentValue(activity),
        //             patient: patient,
        //             activity: activity,
        //             deviceSerial: payload.deviceSerial || '',
        //             router: payload.routerSerial || ''
        //           }
        //           this.props.logActivity.addActivity(dataLogActivity);
        //         }
        //       }
        //     }
        //   }
        // }
      });
    });

    try {
      this.props.dashboard.setPayloadList(payloadList, task);
    } catch (e) {
      console.log('error : payloadList', payloadList);
    }
  }

  async setDataChange(payload, task) {
    const { user, routerNoSignal } = this.props.dashboard.toJS();
    /// Start set status router ///
    if (task === 'realtime') {
      if (payload.routerSerial && payload.deviceSerial === '') {
        if (payload.alertInfo === 'No Signal') {
          let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
          if (!router) {
            this.props.dashboard.setAlertRouter(payload.routerSerial, 'alertDb');
          }
        } else {
          let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
          if (router) {
            this.props.dashboard.resetAlertRouter(payload.routerSerial);
          }
        }
      } else if (payload.routerSerial && payload.deviceSerial) {
        if (payload.alertCritical !== 'true' && payload.alertWarning !== 'true') {
          let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
          if (router) {
            this.props.dashboard.resetAlertRouter(payload.routerSerial);
          }
        }
      }
    }
    /// End set status router ///

    // Find device in page //
    let dataUser = _.find(user, (element) => {
      if (element.patient) {
        return _.find(element.patient.devices, (device) => {
          return device.serial === payload.deviceSerial && device.status === 'ACTIVATE_ON';
        });
      }
    });
    // End Find device in page //
    if (dataUser && payload) {
      try {
        // set alert
        if (payload.alertType) {
          let eventPriority = payload.alertCritical === 'true' ? 'critical' : 'warning';
          this.props.dashboard.setAlert(payload, eventPriority);
        } else {
          const changed = JSON.parse(payload.changed);
          if (changed.a || changed.f === 0 || changed.f === 1 || changed.f === 2) {
            this.props.dashboard.clearAlert(payload.deviceSerial);
          }
        }
        if (payload.changed) {
          // set change
          const changed = JSON.parse(payload.changed);
          if (
            (changed.a && this.validateChange('a', changed.a)) ||
            (changed.f !== null &&
              changed.f !== '' &&
              changed.f !== undefined &&
              this.validateChange('f', changed.f)) ||
            changed.b
            // || (changed.m && payload.alertWarning === 'true' && !changed.a)
          ) {
            this.props.dashboard.setAction(payload);
            if (localStorage.getItem('role_id') === '1' && task === 'realtime') {
              // set logs activity
              if ((changed.f && changed.f === 3) || changed.a || (changed.b < 20 && payload.alertWarning === 'true')) {
                this.props.dashboard.getAlertID(payload.deviceSerial);
                // const { patient } = this.props.dashboard.getAlertID(payload.deviceSerial);
                // let activity = changed.f === 3 ? 12 : changed.a;
                // if (changed.b < 20 && payload.alertWarning === 'true') {
                //   activity = 8;
                // }
                // if (payload.deviceSerial) {
                //   const dataLogActivity = {
                //     id: Math.floor((Math.random() * 10000000) + 1),
                //     variant: payload.alertCritical === 'true' ? 'error' : payload.alertWarning === 'true' ? 'warning' : 'primary',
                //     time: moment().format(),
                //     action: this.getMomentValue(activity),
                //     patient: patient,
                //     activity: activity,
                //     router: payload.routerSerial || '',
                //     deviceSerial: payload.deviceSerial || ''
                //   }
                //   this.props.logActivity.addActivity(dataLogActivity);
                // }
              }
            }
          }
        }
      } catch (e) {
        console.log('error : payload', payload);
      }
    }
  }

  async actionChanges() {
    const { user } = this.props.dashboard.toJS();
    let serials = [];
    (user || []).forEach((data) => {
      if (data.patient) {
        serials = [...serials, ...(data.patient.devices || []).map((item) => item.serial)];
      }
    });

    const lastAction = await this.props.dashboard.lastActivity(serials, false);
    if (lastAction && lastAction.length > 0) {
      let numLoop = [];
      for (let i = 0; i < lastAction.length; i += 50) {
        numLoop.push(i);
      }
      for (const item of numLoop) {
        this.setDataChangeList(lastAction.slice(item, item + 50), 'init');
        // setTimeout(() => {
        //   this.setDataChangeList(lastAction.slice(item, item + 3), 'init');
        // }, 0);
      }
    }
  }

  async subscribeToServer() {
    console.log('--- subscribeToServer --------');
    // FCM
    if (config.firebase.status && localStorage.getItem('fcm_token')) {
      if (localStorage.getItem('select_module')) {
        const selectModule = JSON.parse(localStorage.getItem('select_module'));
        selectModule.forEach((val) => {
          console.log(`subscribeFCM Topic : ${val}_module_alert`);
          this.props.fcm.subscribeFCM(localStorage.getItem('fcm_token'), `${val}_module_alert`);
          this.props.fcm.subscribeFCM(localStorage.getItem('fcm_token'), `${val}_module_acknowledge`);
        });
      }

      messaging.onMessage(async (payload) => {
        if (payload.data && payload.data.data) {
          payload.data.data = JSON.parse(payload.data.data);
          console.log('fcm payload ---> ', payload);
          // await this.setPayload(payload);
        }
      });
    }

    // socket
    if (this.socket) {
      this.socket.disconnect();
      this.socket.close();
      this.socket = null;
    }

    this.socket = socketIOClient(`${config.api.url_socket}`);

    // subscribe to server when reconnect
    this.socket.on('reconnect', async () => {
      // reload data when reconnect
      if (localStorage.getItem('select_module')) {
        //reload list patient
        await this.initBedNoLoading(localStorage.getItem('select_module'));
        await this.actionChanges();
      }

      //reload fixed emergency
      this.getLastFixedEmergencyAlarm();
    });

    // subscribe tenant
    // const tenantId = localStorage.getItem('select_tenant');
    // if (tenantId) {
    //   this.socket.on(`tenant_alert_${tenantId}`, async (payload) => {
    //     console.log('payload tenant alert ---> ', payload);
    //     await this.setPayload(payload);
    //   });

    //   this.socket.on(`tenant_acknowledge_${tenantId}`, async (payload) => {
    //     // console.log('payload tenant acknowledge ---> ',payload);
    //     await this.setPayload(payload);
    //   });
    // }

    if (localStorage.getItem('select_module')) {
      const selectModule = JSON.parse(localStorage.getItem('select_module'));
      (selectModule || []).forEach((val) => {
        this.socket.on(`module_alert_${val}`, async (payload) => {
          // console.log('payload alert ---> ', payload);
          await this.setPayload(payload);
        });
        this.socket.on(`module_acknowledge_${val}`, async (payload) => {
          // console.log('payload acknowledge ---> ',payload);
          await this.setPayload(payload);
        });
        this.socket.on(`module_fetch_${val}`, async (payload) => {
          // console.log('payload fetch ---> ',payload);
          await this.setPayload(payload);
        });
        this.socket.on(`module_change_password_${val}`, async (payload) => {
          // console.log('payload changepassword ---> ',payload);
          await this.setPayload(payload);
        });
      });
    }

    if (localStorage.getItem('select_group')) {
      const selectedGroupId = JSON.parse(localStorage.getItem('select_group'));
      let { groups } = this.props.group.toJS();
      let groupSelect = (groups || []).find((val) => +val.id === selectedGroupId);
      ((groupSelect && groupSelect.subGroups) || []).forEach((val) => {
        this.socket.on(`module_alert_router_no_signal_${val.id}`, async (payload) => {
          // console.log('payload router no signal ---> ',payload);
          await this.setPayload(payload);
        });
      });
    }

    // fixed emergency alert
    await this.subscribeFixedEmergencyNotification();
  }

  async unSubscribeToServer() {
    // FCM
    if (config.firebase.status && localStorage.getItem('fcm_token')) {
      if (localStorage.getItem('select_module')) {
        const selectModule = JSON.parse(localStorage.getItem('select_module'));
        for (const val of selectModule || []) {
          console.log(`unSubscribeFCM Topic : ${val}_module_alert`);
          await this.props.fcm.unSubscribeFCM(localStorage.getItem('fcm_token'), `${val}_module_alert`);
          await this.props.fcm.unSubscribeFCM(localStorage.getItem('fcm_token'), `${val}_module_acknowledge`);
        }
      }
    }
  }

  async subscribeFixedEmergencyNotification() {
    const subgroupIds = this.getSubgroupIds();
    (subgroupIds || []).forEach((id) => {
      this.socket.on(`module_fixed_alert_${id}`, async (payload) => {
        console.log('payload fixed alert ---> ', payload);
        await this.setPayload(payload);
      });

      this.socket.on(`module_fixed_acknowledge_${id}`, async (payload) => {
        console.log('payload fixed acknowledge ---> ', payload);
        await this.setPayload(payload);
      });
    });
  }

  getNotificationAlert(id) {
    return [
      `module_alert_getup_${id}`,
      `module_alert_movement_${id}`,
      `module_alert_row_battery_${id}`,
      `module_alert_device_no_signal_${id}`,
      `module_alert_not_turn_for_${id}`,
      `module_alert_no_movement_for_${id}`,
      `module_alert_fall_${id}`,
      `module_alert_out_of_area_${id}`,
      `module_alert_into_of_area_${id}`,
      `module_alert_walking_at_night_${id}`,
      `module_alert_recharge_battery_${id}`,
      `module_alert_device_bad_signal_${id}`,
      `module_alert_emergency_alarm_${id}`,
    ];
  }

  async setPayload(payload) {
    // const dashboard = this;
    if (payload.length > 0) {
      if (config.groupNotification) {
        // console.log('payload',payload);
        await this.setDataChangeList(payload, 'realtime');
      } else {
        // const datanotifyAPIStart = +payload.data.apiStart;
        // const dataDisplayWebStart = +Date.now();
        // const time = {};
        // time.package10 = dataDisplayWebStart - datanotifyAPIStart;
        // if (time.package10 < 10000) {
        //   const { dbStatus } = dashboard.props.dashboard.toJS();
        //   if (payload.data.dbStatus === "true") {
        //     if (dbStatus.status === false && dbStatus.id) {
        //       Alert.close(dbStatus.id);
        //       dashboard.props.dashboard.resetDbStatus();
        //     }
        //   } else {
        //     if (dbStatus.status === true && dbStatus.id === null) {
        //       let alertDb = Alert.error("Header", {
        //         customFields: {
        //           dbStatus: false,
        //         },
        //         position: "bottom",
        //         timeout: "none",
        //         type: "critical",
        //       });
        //       dashboard.props.dashboard.setAlertDb(alertDb);
        //     }
        //   }
        //   this.setDataChange(payload.data, "realtime");
        // }
      }
    } else {
      // sync data
      if (payload.data && payload.data.type) {
        if (payload.data && (payload.data.type === 'group' || payload.data.type === 'subgroup')) {
          // redirect login
          this.signOut();
          window.location.replace('/login');
        } else if (payload.data && payload.data.type === 'acknowledge') {
          const acknowledgeFor = payload.data.prevNotification;

          Alert.success('Header', {
            customFields: {
              dbStatus: true,
              type: 'info',
              userName: payload.data.userName,
              patient: payload.data.patient,
              notification: acknowledgeFor,
            },
            position: 'top-right',
            timeout: 3000,
          });

          const acknowledge = {
            notification: acknowledgeFor,
            patient: payload.data.patient,
            user: {
              userName: payload.data.userName,
            },
            createdDate: Date.now(),
            unRead: true,
          };
          this.props.acknowledge.addAcknowledge(acknowledge);

          const newNotification = {
            patientId: payload.data.patient ? payload.data.patient.id : null,
            subGroupId: payload.data.subGroupId,
            notifications: payload.data.newNotification,
          };
          this.props.dashboard.setPayloadFixedEmegencyAlarm(newNotification, 'acknowledge');
          await this.setDataChangeList([{ data: newNotification }], 'realtime');
        } else if (payload.data && payload.data.type === 'changePassword') {
          if (localStorage.getItem('user') === payload.data.userName) {
            clearLocalStorage();
            window.location.href = '/login';
          }
        } else {
          await this.initBed(localStorage.getItem('select_module'));
          this.actionChanges();
        }
      }
    }
  }

  async setFilterLog(hour) {
    let dataLastLog = await this.props.logActivity.getLastLogActivity(hour);
    (dataLastLog || []).map((val) => {
      if (val.device_serial && val.changed) {
        let changed = {};
        try {
          changed = JSON.parse(val.changed);
        } catch (e) {
          changed = {};
        }
        if (
          (changed.a && this.validateChange('a', changed.a)) ||
          (changed.f && this.validateChange('f', changed.f)) ||
          changed.b
        ) {
          if ((changed.f && changed.f === 3) || changed.a || (changed.b < 20 && val.alert_action === 'true')) {
            const dataPatient = this.props.dashboard.getAlertID(val.device_serial);
            if (dataPatient && dataPatient.patient) {
              let activity = changed.f === 3 ? 12 : changed.a;
              if (changed.b < 20 && val.alert_action === 'true') {
                activity = 8;
              }
              val.variant = val.alert_fall === 'true' ? 'error' : val.alert_action === 'true' ? 'warning' : 'primary';
              val.time = val.created_date;
              val.action = this.getMomentValue(activity);
              val.patient = dataPatient.patient;
              val.activity = activity;
              val.router = val.router_serial || '';
            }
          }
        }
      }
      return val;
    });
    let filterLog = (dataLastLog || []).filter((val) => val.patient);
    await this.props.logActivity.setLastLogActivity(filterLog);
  }

  // async setSelcteAllModules() {
  //   let subgroupAll = [];
  //   let { ListSubGroups } = this.props.subGroup.toJS();
  //   if (localStorage.getItem("role_id") !== "1") {
  //     const subGroupPermission = JSON.parse(
  //       localStorage.getItem("subgroup_permission")
  //     );
  //     ListSubGroups = (ListSubGroups || []).filter((val) =>
  //       subGroupPermission.includes(val.id)
  //     );
  //   }

  //   ListSubGroups.forEach((val) => {
  //     subgroupAll.push(val.id);
  //   });
  //   subgroupAll.sort((a, b) => a - b);
  //   subgroupAll = JSON.stringify(subgroupAll);

  //   localStorage.setItem("select_module", subgroupAll);
  //   this.setState({ module: localStorage.getItem("select_module") });
  //   await this.initBedNoLoading(localStorage.getItem("select_module"));
  //   this.initRouter(localStorage.getItem("select_module"));
  //   this.subscribeToServer();
  //   this.props.patient.findMapBySubgroupIds(
  //     localStorage.getItem("select_module")
  //   );
  //   const subgrouplist = JSON.parse(subgroupAll);
  //   if (subgrouplist.length > 0) {
  //     const selectedSubGroup = ListSubGroups.find(
  //       (val) => val.id === subgrouplist[0]
  //     );
  //     localStorage.setItem(
  //       "subgroup_type",
  //       selectedSubGroup && selectedSubGroup.type
  //         ? selectedSubGroup.type
  //         : "hospital"
  //     );
  //   }
  //   setTimeout(() => {
  //     this.actionChanges();
  //   }, 0);
  // }

  validateChange(task, value) {
    if (task === 'a') {
      switch (value) {
        // case 1: case 2: case 3: case 4: case 5: case 6: case 8: case 9: case 10: case 11: case 14: case 15: case 16: case 17: case 18: case 19:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 14:
        case 15:
        case 16:
        case 17:
        case 100:
          return true;
        default:
          return false;
      }
    }
    if (task === 'f') {
      switch (value) {
        case 0:
        case 1:
        case 2:
        case 3:
          return true;
        default:
          return false;
      }
    }
    if (task === 'b') {
      return true;
    }
    if (task === 'm') {
      return true;
    }
  }

  clearAlert(bed) {
    this.props.dashboard.updateToken();
    this.props.dashboard.clearAlert(bed);
  }

  acknowledge(data) {
    this.props.dashboard.updateToken();
    this.props.dashboard.ackAlert(data);
  }

  acknowledgeFixedEmegency(data) {
    this.props.dashboard.updateToken();
    const alerts = (data.alerts || []).map((a) => {
      return {
        alertId: a.alertId,
        alertType: a.alertType,
      };
    });
    this.props.dashboard.ackFixedEmergency(data, alerts);
  }

  isEmergencyButton = (devices) => {
    for (const device of devices || []) {
      const { deviceVersion } = device;
      if (deviceVersion) {
        const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
        if (property) {
          if (property.alarmTrigger || property.alarmOnoff) {
            return true;
          }
        }
      }
    }
    return false;
  };

  isEmergencyDevice = (device) => {
    const { deviceVersion } = device;
    if (deviceVersion) {
      const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
      if (property) {
        if (property.alarmTrigger || property.alarmOnoff) {
          return true;
        }
      }
    }
    return false;
  };

  box = (data, classes) => {
    const { t } = this.props;
    if (data.patient) {
      const dob = moment(new Date(data.patient.dob)).startOf('day');
      const now = moment(new Date());
      const age = now.diff(dob, 'year');
      // const ageDifMs = Date.now() - new Date(data.patient.dob).getTime();
      // const ageDate = new Date(ageDifMs); // miliseconds from epoch
      // const age = Math.abs(ageDate.getUTCFullYear() - 1970);
      const hn =
        data.patient.hn && data.patient.hn.length >= 13
          ? data.patient.hn.substr(0, 13)
          : `${config.style.useHN ? 'HN-' : 'ID-'}${data.patient.hn}`;
      let name = '';
      if (localStorage.getItem('i18nextLng') === 'th-TH') {
        if (data.patient.firstname || data.patient.lastname) {
          name = `${data.patient.firstname ?? ''} ${data.patient.lastname ?? ''}`;
        } else {
          name = `${data.patient.firstnameEn ?? ''} ${data.patient.lastnameEn ?? ''}`;
        }
      }
      if (localStorage.getItem('i18nextLng') === 'en-EN') {
        if (data.patient.firstnameEn || data.patient.lastnameEn) {
          name = `${data.patient.firstnameEn ?? ''} ${data.patient.lastnameEn ?? ''}`;
        } else {
          name = `${data.patient.firstname ?? ''} ${data.patient.lastname ?? ''}`;
        }
      }

      const hasDevices = data.patient && data.patient.devices && data.patient.devices.length > 0;
      const deviceWithOutEmergency = hasDevices
        ? data.patient.devices.filter((d) => d.deviceVersion && d.deviceVersion.category !== 'EMERGENCY_BUTTON')
        : [];
      const isBadStatus =
        deviceWithOutEmergency &&
        deviceWithOutEmergency.length > 0 &&
        deviceWithOutEmergency.find((d) => {
          const result =
            d.status === 'ACTIVATE_OFF' ||
            (!d.action && d.status === 'ACTIVATE_ON') ||
            (d.action &&
              ((d.action.alerts && d.action.alerts.find((a) => a.alertType === 504 || a.alertType === 513)) ||
                d.action.nosignal === 'true' ||
                (d.action.changed && d.action.changed.a === null && d.status === 'ACTIVATE_ON')));
          return result;
        });
      const hasEmergencyDevice = hasDevices
        ? data.patient.devices.find((d) => d.deviceVersion && d.deviceVersion.category === 'EMERGENCY_BUTTON')
        : null;
      const alertWithEmergency =
        hasEmergencyDevice &&
        hasEmergencyDevice.action &&
        hasEmergencyDevice.action.alerts.length > 0 &&
        hasEmergencyDevice.action.alerts.find((a) => a.alertType === 514);

      return (
        <Fragment>
          <div className={classes.visitsNumberContainer}>
            <Grid container direction='row' justify='space-between' alignItems='center'>
              <Grid item xs={12}>
                <div
                  style={{
                    display: 'flex',
                    position: 'relative',
                    marginBottom: 5,
                  }}
                >
                  {this.state.gridPage === 2 && name.length > 15 ? (
                    <Tooltip
                      title={name}
                      classes={{ tooltip: classes.tooltipFont }}
                      interactive
                      PopperProps={{
                        popperOptions: {
                          modifiers: {
                            offset: {
                              enabled: true,
                              offset: '0px, -20px',
                            },
                          },
                        },
                      }}
                    >
                      <Typography
                        variant='subtitle1'
                        className={classnames(classes.materialIconText, classes.hiddenText)}
                      >
                        {name}
                      </Typography>
                    </Tooltip>
                  ) : (
                    <Typography
                      variant='subtitle1'
                      className={classnames(
                        classes.materialIconText,
                        // classes.hiddenText
                      )}
                    >
                      {name}
                    </Typography>
                  )}

                  <div className={classes.buttonBox}>
                    {/* {votedAlert &&
                      (votedAlert.alertWarning === "true" ||
                        votedAlert.alertCritical === "true") &&
                      !this.isMuted(data) && (
                        <IconButton
                          classes={{ root: classes.moreButton }}
                          aria-label="delete"
                          id="clear"
                          onClick={() => this.clearAlert(data)}
                        >
                          <Icons.NotificationsOff />
                        </IconButton>
                      )} */}
                    {/* {data.alert && data.alert.acknowledge === true && (
                      <IconButton
                        classes={{ root: classes.moreButton }}
                        aria-label="delete"
                        id="acknowledge"
                        onClick={() => this.acknowledge(data)}
                      >
                        <Icons.HowToReg />
                      </IconButton>
                    )} */}
                    <IconButton
                      // color="secondary"
                      classes={{ root: classes.moreButton }}
                      aria-owns='widget-menu'
                      aria-haspopup='true'
                      onClick={(e) => this.setMoreMenuOpen(e, data.patient)}
                      buttonRef={this.props.setMoreButtonRef}
                    >
                      {/* <Icons.MoreVert /> */}
                      <svg viewBox='0 0 28 26' width='24'>
                        <use xlinkHref={`/images/menus-v1.svg#moremenus`} />
                      </svg>
                    </IconButton>
                  </div>
                </div>
              </Grid>

              <Grid item xs={1}>
                <Typography variant='subtitle2' weight='height' className={classes.materialIconText} color='primary'>
                  <i
                    className={
                      data.patient.gender === 'M'
                        ? `${classes.iconColor} fa fa-mars`
                        : `${classes.iconColor} fa fa-venus`
                    }
                  />
                </Typography>
              </Grid>
              <Grid
                item
                xs={10}
                style={{
                  display: 'flex',
                  position: 'relative',
                  marginRight: 5,
                }}
              >
                <Typography
                  variant='subtitle2'
                  // className={classes.materialIconText}
                >
                  {hn} | {age} {t('yr')}
                </Typography>
                <div
                  id={`vitalsign-${hn}`}
                  className={classes.buttonVitalSign}
                  onClick={() => this.handleClickOpenDialogVitalSigns(data.patient)}
                >
                  <svg width='20' height='20' viewBox='0 0 20 20'>
                    <use xlinkHref={`/images/vital.svg#vital`} />
                  </svg>
                </div>
              </Grid>
            </Grid>
          </div>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <Grid item xs={10} className={classes.customizeBoxIcon}>
              {hasEmergencyDevice && !alertWithEmergency ? (
                // <img src={iconSOSGray} alt="sos" width="26" />
                <svg width='26' height='26' viewBox='0 0 47 45'>
                  <use xlinkHref={`/images/sos-v4.svg#sosgray`} />
                </svg>
              ) : (
                hasEmergencyDevice &&
                alertWithEmergency && (
                  // <img src={iconSOS} alt="sos" width="26" />
                  <svg width='26' height='26' viewBox='0 0 47 45'>
                    <use xlinkHref={`/images/sos-v4.svg#sos`} />
                  </svg>
                )
              )}
            </Grid>
            <Grid item xs={2} className={classes.iconStatus}>
              {hasDevices ? (
                <Typography size='md' component='div'>
                  {deviceWithOutEmergency.length > 0 ? (
                    <div>
                      {deviceWithOutEmergency.length === 1 ? (
                        <div style={{ marginRight: 7 }}>
                          {isBadStatus ? (
                            <Tooltip
                              title={`${t('since')} ${getTimeFormatted(
                                deviceWithOutEmergency[0].action && deviceWithOutEmergency[0].action.timestamp,
                                t,
                              )}`}
                              classes={{ tooltip: classes.tooltipFont }}
                            >
                              {/* <Icons.SignalWifiOff
                                style={{ width: 24, height: 22 , color: "#B4B4B4", marginRight: 5}}
                              /> */}
                              <svg viewBox='0 0 30 27' width='24' height='24'>
                                <use xlinkHref={`/images/signal.svg#badsignal`} />
                              </svg>
                            </Tooltip>
                          ) : (
                            <div style={{ marginRight: 8 }}>
                              {deviceWithOutEmergency &&
                              deviceWithOutEmergency[0].action &&
                              deviceWithOutEmergency[0].action.changed &&
                              deviceWithOutEmergency[0].action.changed.b ? (
                                this.battery(
                                  deviceWithOutEmergency[0].action.changed.b,
                                  deviceWithOutEmergency[0].action.batteryTimestamp
                                    ? deviceWithOutEmergency[0].action.batteryTimestamp
                                    : deviceWithOutEmergency[0].action.timestamp,
                                )
                              ) : (
                                <div style={{ marginRight: '-9px' }}>
                                  <Tooltip title={t('signal')} classes={{ tooltip: classes.tooltipFont }}>
                                    <svg viewBox='0 0 30 24' width='24' height='24'>
                                      <use xlinkHref={`/images/signal.svg#goodsignal`} />
                                    </svg>
                                  </Tooltip>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div style={{ marginRight: 5 }}>
                          {isBadStatus ? (
                            <IconButton
                              className={classes.buttonOption}
                              aria-owns='more-menu'
                              aria-haspopup='true'
                              onClick={() => this.setOpenStatus(data.patientId)}
                            >
                              <Icons.Warning style={{ color: '#FFC260' }} />
                            </IconButton>
                          ) : (
                            <IconButton
                              className={classes.buttonOption}
                              aria-owns='more-menu'
                              aria-haspopup='true'
                              onClick={() => this.setOpenStatus(data.patientId)}
                            >
                              <Icons.CheckCircle
                                style={{ color: '#55C1B0' }}
                                // className={classes.iconColor}
                              />
                            </IconButton>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    ''
                  )}
                </Typography>
              ) : (
                ''
              )}
            </Grid>
          </Grid>
        </Fragment>
      );
    } else {
      return <Fragment />;
    }
  };

  getContent = (users) => {
    const { classes } = this.props;
    const { gridPage } = this.state;
    let result = users.map((data) => {
      // let title = data.roomName && data.name ? `${data.roomName}/${data.name}` : data.roomName || data.name;
      return (
        <Grid
          className={classes.boxContent}
          id={data.patient && data.patient.hn ? data.patient.hn : ''}
          item
          lg={this.props.logActivity.display ? 3 : gridPage || 2}
          md={4}
          sm={6}
          xs={12}
          key={`box-${data.id}`}
        >
          <Widget
            // title={title}
            upperTitle
            bodyClass={classes.fullHeightBody}
            // className={classes.card}
            data={data}
            hasPatient={data.patient != null}
            gridPage={gridPage}
          >
            {this.box(data, classes)}
          </Widget>
        </Grid>
      );
    });
    return result;
  };

  getColumn = (users) => {
    const { classes, t } = this.props;
    return (
      <Paper className={classes.paperList}>
        <Table aria-label='simple table'>
          <TableHead>
            <TableRow className={classes.headTable}>
              <TableCell className={classes.tableCell} />
              {this.state.table.seeHN && (
                <TableCell className={classes.tableCellHiding} align='left'>
                  {config.style.useHN ? 'HN' : 'ID'}
                </TableCell>
              )}
              {this.state.table.seeName && (
                <TableCell className={classes.tableCell} align='left'>
                  {t('name')}
                </TableCell>
              )}
              {config.features.dashboard.roomName && this.state.table.seeRoom && (
                <TableCell className={classes.tableCellHiding} align='left'>
                  {t('room')}
                </TableCell>
              )}
              {this.state.table.seeStatus && (
                <TableCell className={classes.tableCell} align='left'>
                  {t('status')}
                </TableCell>
              )}
              {this.state.table.seeAlert && (
                <TableCell className={classes.tableCell} align='left'>
                  {t('alert')}
                </TableCell>
              )}

              {this.state.table.seeAlertTime && (
                <TableCell className={classes.tableCell} align='left'>
                  {t('time')}
                </TableCell>
              )}

              <TableCell className={classes.tableCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((row, index) => (
              <ContentRow
                data={row}
                key={index}
                setMoreMenuOpen={this.setMoreMenuOpen}
                handleClickOpenDialogAddPatient={this.handleClickOpenDialogAddPatient}
                handleClickOpenDialogActivities={this.handleClickOpenDialogActivities}
                handleClickOpenDialogContact={this.handleClickOpenDialogContact}
                handleClickOpenDialogVitalSigns={this.handleClickOpenDialogVitalSigns}
                showTable={this.state.table}
                setOpenStatus={this.setOpenStatus}
              />
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  };

  accessibility = (activite) => {
    const { classes } = this.props;
    let result = '';
    switch (activite) {
      case 1:
      case 10:
      case 14:
      case 15:
      case 16:
      case 17:
        result = <Icons.LocalHotel className={classes.iconActivity} />;
        break;
      case 2:
        result = <Icons.AirlineSeatReclineNormal className={classes.iconActivity} />;
        break;
      case 3:
        // result = <Icons.Accessibility className={classes.iconActivity} />;
        result = <img src={iconGetUp} alt='getup' width='30' />;
        break;
      case 4:
        result = <Icons.DirectionsWalk className={classes.iconActivity} />;
        break;
      case 5:
        result = <Icons.DirectionsRun className={classes.iconActivity} />;
        break;
      case 6:
        result = <img src={iconJump} alt='jump' width='30' />;
        break;
      case 8:
        result = <Icons.BatteryAlert className={classes.iconActivity} />;
        break;
      case 504:
        result = <img src={iconNosignal} alt='nosignal' width='30' />;
        break;
      case 11:
        result = <img src={iconNoMovement} alt='nomovement' width='30' />;
        break;
      case 18:
        result = <Icons.TransferWithinAStation className={classes.iconActivity} />;
        break;
      case 19:
        result = <Icons.DirectionsWalk className={classes.iconActivity} />;
        break;
      case 100:
        result = <Icons.LocationOn className={classes.iconActivity} />;
        break;
      case 101:
        result = <Icons.NotificationsActive className={classes.iconActivity} />;
        break;
      default:
        result = <Icons.Help className={classes.iconActivity} />;
        break;
    }
    return result;
  };

  battery = (level, timestamp) => {
    const { classes, t } = this.props;
    let result = '';
    if (level > 0 && level <= 20) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery10`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 20 && level <= 40) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery25`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 40 && level <= 50) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery50`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 50 && level <= 70) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery50`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 70 && level <= 80) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery75`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 80 && level <= 90) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery75`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 90) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery100`} />
          </svg>
        </Tooltip>
      );
    }
    return result;
  };

  getMomentValue = (value) => {
    const { t } = this.props;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('movement')}`;
        break;
      case 8:
        result = `${t('low_battery')}`;
        break;
      case 9:
        result = `${t('no_signal')}`;
        break;
      case 10:
        result = `${t('not_turn_for')}`;
        break;
      case 11:
        result = `${t('no_movement')}`;
        break;
      case 12:
        result = `${t('falling')}`;
        break;
      case 13:
        result = `${t('unknown')}`;
        break;
      case 14:
        result = `${t('lying_on_back')}`;
        break;
      case 15:
        result = `${t('lying_on_stomach')}`;
        break;
      case 16:
        result = `${t('lying_on_left_side')}`;
        break;
      case 17:
        result = `${t('lying_on_right_side')}`;
        break;
      case 18:
        result = `${t('out_of_area')}`;
        break;
      case 19:
        result = `${t('walking_at_night')}`;
        break;
      case 100:
        result = `${t('detect_location')}`;
        break;
      case 101:
        result = `${t('alert_emergency_alarm')}`;
        break;
      default:
        break;
    }
    return result;
  };

  actionStatus = (icon) => {
    const { classes } = this.props;
    return (
      <Fab
        color='default'
        aria-label='action'
        size='small'
        // disabled
        variant='extended'
        className={classes.activityBox}
      >
        {icon}
      </Fab>
    );
  };

  getRouterPlace = (serial) => {
    const { routers } = this.props.router.toJS();
    const routerData = (routers || []).find((val) => val.serial === serial);
    if (routerData) {
      return routerData.place;
    }
  };

  getRouterArea = (serial) => {
    let { areas } = this.props.area.toJS();
    let name = '';
    (areas.data || []).map((val) => {
      const result = (val.routers || []).find((routers) => routers.serial === serial);
      if (result) {
        name = val.name;
      }
      return val;
    });
    return name;
  };

  getAlertInfo = (value, serial, time, alertAreaName) => {
    const { t } = this.props;
    let numberOfDay = time / 60 / 24;
    let dayFormat = `${numberOfDay === 1 ? numberOfDay + ' ' + t('day') : numberOfDay + ' ' + t('days')}`;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('lying_on_back')}`;
        break;
      case 8:
        result = `${t('lying_on_stomach')}`;
        break;
      case 9:
        result = `${t('lying_on_left_side')}`;
        break;
      case 10:
        result = `${t('lying_on_right_side')}`;
        break;
      case 501:
        result = `${t('get_up')}`;
        break;
      case 502:
        result = `${t('movement')}`;
        break;
      case 503:
        result = `${t('low_battery')}`;
        break;
      case 504:
        result = `${t('alert_last_seen')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 505:
        result = `${t('alert_router_no_signal')}`;
        break;
      case 506:
        result = `${t('alert_not_turn')}`;
        break;
      case 507:
        result = `${t('alert_no_movement')} > ${numberOfDay === 0 ? '' : dayFormat}`;
        break;
      case 508:
        result = `${t('alert_fall')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 509:
        result = ` @ ${t('alert_exit')} ${alertAreaName ? alertAreaName : this.getRouterArea(serial)}`;
        break;
      case 510:
        result = ` @ ${alertAreaName ? alertAreaName : this.getRouterArea(serial)}`;
        break;
      case 511:
        result = `${t('alert_walking')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 512:
        result = `${t('alert_deactivate_recharge')}`;
        break;
      case 513:
        result = `${t('alert_bad_signal')}`;
        break;
      case 514:
        result = `${t('alert_emergency_alarm')}`;
        break;
      default:
        break;
    }
    return result;
  };

  handleChange = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
    if (name === 'group') {
      localStorage.setItem('select_group', value);
      this.initMap(value);
      let { groups } = this.props.group.toJS();
      let groupSelect = (groups || []).find((val) => +val.id === +value);
      this.props.subGroup.setSubGroup(groupSelect ? groupSelect.subGroups || [] : []);
      this.setState({ module: 0 });
    }
    if (name === 'module') {
      //unsubscribe fcm
      this.unSubscribeToServer();
      const targetVal = event.target.value;
      localStorage.setItem('select_module', targetVal);
      const selectedGroupId = localStorage.getItem('select_group');
      const subGroups = await this.props.subGroup.getSubGroupByGroupID(selectedGroupId);
      const subgrouplist = JSON.parse(targetVal);
      if (subgrouplist.length > 0) {
        const selectedSubGroup = subGroups.find((val) => val.id === subgrouplist[0]);
        localStorage.setItem(
          'subgroup_type',
          selectedSubGroup && selectedSubGroup.type ? selectedSubGroup.type : 'hospital',
        );
      } else {
        localStorage.removeItem('subgroup_type');
        // localStorage.setItem("subgroup_type", "hospital");
      }
      await this.initBed(targetVal);
      this.initRouter(targetVal);
      this.subscribeToServer();
      setTimeout(() => {
        this.actionChanges();
      }, 0);

      this.props.patient.findMapBySubgroupIds(targetVal);
      // this.props.dashboard.setLoading(true);
      // setTimeout(function () { window.location.replace('dashboard') }, 1000);

      await this.props.acknowledge.getAcknowledge();
    }
  };

  handleChangePage = async (value) => {
    localStorage.setItem('last_view', 'map');
    this.setState({ page: value });
    this.props.logActivity.showLog(false);
  };

  handleClickMobile = (event) => {
    this.setState({
      anchorEl: null,
      page: 0,
      gridPage: 4,
    });
  };

  handleClick = (event) => {
    // if (localStorage.getItem("role_id") === '1') {
    //   this.setState({
    //     anchorEl: null,
    //     page: 0,
    //     gridPage: 3
    //   });
    //   localStorage.setItem("last_view", '4');
    // } else {
    this.setState({
      anchorEl: event.currentTarget,
    });
    // }
  };

  handleClickList = (event) => {
    this.setState({
      setList: event.currentTarget,
    });
    this.handleChangeGrid('listview');
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleCloseSound = () => {
    Alert.closeAll();
    this.setState({
      soundEmergincy: false,
    });
  };

  handleCloseDialog = () => {
    this.props.patient.setDeviceList([]);
    this.setState({
      dialogActivities: { open: false, id: null },
      dialogSetting: { open: false, id: null },
      dialogGarminAccount: { open: false, id: null },
      dialogPatient: { open: false, id: null, bedInfo: null, tenantId: null },
      dialogDevice: { open: false, id: null },
      dialogContact: { open: false, id: null, readOnly: false },
      dialogMovement: { open: false, id: null },
      dialogCreateAccount: { open: false, id: null },
      dialogVitalSigns: { open: false, id: null },
    });
    // this.setState({ dialogSetting: { open: false, id: null } });
    // this.setState({ dialogPatient: { open: false, id: null, bedInfo: null } });
    // this.setState({ dialogDevice: { open: false, id: null } });
    // this.setState({
    //   dialogContact: { open: false, id: null, readOnly: false },
    // });
    // this.setState({ dialogMovement: { open: false, id: null } });
    // this.setState({ dialogCreateAccount: { open: false, id: null } });
  };

  handleCloseList = () => {
    this.setState({
      setList: null,
    });
  };

  handleChangeGrid = (task) => {
    localStorage.setItem('last_view', task);

    if (task === '4') {
      this.setState({
        anchorEl: null,
        page: 0,
        gridPage: 3,
      });
    } else if (task === '6') {
      this.setState({
        anchorEl: null,
        page: 0,
        gridPage: 2,
      });
    } else if (task === 'listview') {
      let sortData = localStorage.getItem('sort');
      if (!localStorage.getItem('sort')) {
        localStorage.setItem('sort', 'priority-new');
      } else {
        localStorage.setItem('sort', sortData);
      }
      this.setState({
        setList: null,
        page: 1,
        list: 'listview',
        sort: localStorage.getItem('sort'),
      });
    } else if (task === 'listmanage') {
      this.setState({
        setList: null,
        page: 1,
        list: 'listmanage',
      });
    }
  };

  handleChangeSort = (e) => {
    localStorage.setItem('sort', e.target.value);
    this.setState({
      sort: e.target.value,
    });
  };

  async signOut() {
    localStorage.removeItem('id_token');
    localStorage.removeItem('role');
    localStorage.removeItem('role_id');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('fcm_token');
    localStorage.removeItem('location_permission');
    localStorage.removeItem('group_permission');
    localStorage.removeItem('subgroup_permission');
    localStorage.removeItem('select_module');
    localStorage.removeItem('select_group');
    localStorage.removeItem('subgroup_type');
    localStorage.removeItem('sort');
    localStorage.removeItem('last_view');
    localStorage.removeItem('tenantInfo');
    localStorage.removeItem('tenant_permission');
    localStorage.removeItem('select_tenant');
  }

  async chageActivate(patient) {
    let device = patient.devices;
    device.map((val) => {
      val.status = val.status === 'ACTIVATE_ON' ? 'ACTIVATE_OFF' : 'ACTIVATE_ON';
      return val;
    });
    try {
      await this.props.dashboard.assignDevice(device, patient.id);
    } catch (err) {
      notification.error({
        message: `error`,
        description: err.error.message,
        top: '100px',
      });
    }
  }

  handleClickOpenDialogActivities = async (patient) => {
    try {
      if (patient) {
        this.props.vitalsign.resetVitalSigns();
        this.props.summary.resetSummary(true);
        await this.props.summary.getGraphAvailableDate(patient.id);
        this.props.summary.getVitalSignDate(patient.id);
        this.props.summary.getAssignedDeviceDate(patient.id);
        config.features.report.garmin && this.props.summary.getGarminDate(patient.id);

        let queryOption = {};
        if (localStorage.getItem('role_id') === '1') {
          queryOption = {
            activity: true,
            movement: true,
            alert: true,
            location: true,
            battery: true,
            admin: true,
            device: true,
          };
        } else {
          queryOption = {
            activity: true,
            movement: true,
            location: true,
          };
        }

        this.props.summary.getSummary(patient.id, new Date(), queryOption);
        const { since } = this.props.vitalsign.toJS();

        const queryLastVitalsign = {
          heartrate: true,
          temperature: true,
          bloodPressure: true,
          spo2: true,
          respirationRate: true,
        };

        const querySummaryVitalsign = {
          heartrate: true,
          temperature: true,
          bloodPressure: true,
          spo2: true,
          respirationRate: true,
          since,
        };

        this.props.summary.getSummaryReport(patient.id, new Date());
        this.props.summary.getSummaryReportAsPeriod(patient.id, new Date(), 'week', ['sleep', 'event']);
        this.props.summary.getSummaryLocationAsPeriod(patient.id, new Date(), 'week');
        this.props.vitalsign.getLastVitalSign(patient.id, new Date(), queryLastVitalsign);
        this.props.vitalsign.getSummaryVitalSign(patient.id, new Date(), querySummaryVitalsign);
        config.features.report.garmin &&
          this.props.smartwatchsummary.summaryVitalSigns(patient.id, new Date(), 'daily', [
            'heartrate',
            'spo2',
            'respiration',
          ]);
        // this.props.smartwatchsummary.getAvailableDate(patient.id);
        const now = new Date();
        const prevMonth = this.props.patientsummaryalert.getDefaultStartdateForPatientSummaryAlert(new Date());
        this.props.patientsummaryalert.getPatientSummaryAlert(patient.id, prevMonth, now);

        this.setState({
          dialogActivities: { open: true, id: patient.id },
          isMoreMenuOpen: null,
        });
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  setMoreMenuOpen = async (event, data) => {
    this.setState({
      isMoreMenuOpen: event.currentTarget,
      patientData: data,
    });
  };

  setMoreMenuClose = () => {
    this.setState({
      isMoreMenuOpen: null,
    });
  };

  setOpenStatus = (id) => {
    this.setState({
      dialogStatus: {
        open: true,
        id: id,
      },
    });
  };

  setCloseStatus = () => {
    this.setState({
      dialogStatus: {
        open: false,
        id: null,
      },
    });
  };

  getMuiTheme = () =>
    createMuiTheme({
      ...themes.list,
      ...overrides,
      typography: {
        fontFamily: ['Kanit', 'sans-serif'].join(','),
        useNextVariants: true,
      },
    });

  formatDate(input) {
    // eslint-disable-next-line
    var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;
    if (regex_date.test(input)) {
      const datePart = input.match(/\d+/g),
        year = +datePart[0] + 543, // get only two digits
        month = datePart[1],
        day = datePart[2];
      return day + '/' + month + '/' + year;
    } else {
      return input;
    }
  }

  initDataPatient = async (patient = null) => {
    if (patient) {
      let dashboard = this.props.dashboard.toJS();
      let findData = (dashboard.user || []).find((item) => item.patientId === patient.id);
      findData.patient.dob = this.formatDate(findData.patient.dob);
      this.props.patient.setData(findData);
      this.props.patient.setHnStatus(true);
    } else {
      this.props.patient.setData({
        search: false,
        name: '',
        patient: {
          hn: '',
          firstname: '',
          lastname: '',
          firstnameEn: '',
          lastnameEn: '',
          gender: 'M',
          dob: '00/00/0000',
        },
      });
      await this.props.patient.setHnStatus(true);
    }
  };

  handleClickOpenDialogAddPatient = async (bedId = null, subgroupId = null) => {
    const selectModule = JSON.parse(localStorage.getItem('select_module'));
    if (selectModule.length > 0) {
      await this.initDataPatient();
      const bedInfo = bedId ? { id: bedId, subGroupId: subgroupId } : { subGroupId: selectModule[0] };
      const subGroup = await this.props.subGroup.getSubgroupById(bedInfo.subGroupId);
      if (subGroup) {
        this.setState({
          dialogPatient: { open: true, bedInfo, tenantId: subGroup.tenantId },
        });
      }
    }
  };

  handleClickOpenDialogEditPatient = async (patient) => {
    await this.initDataPatient(patient);
    this.setState({
      dialogPatient: {
        open: true,
        id: patient.id,
        bedInfo: null,
        tenantId: null,
      },
      isMoreMenuOpen: null,
    });
  };

  handleClickOpenDialogContact = async (patient, readOnly = false) => {
    try {
      await this.initDataPatient(patient);
      const contactPersons = await this.props.contactperson.findContactPersonByPatientId(patient.id);
      this.props.contactperson.setContactData(contactPersons);
      this.setState({
        dialogContact: {
          open: true,
          id: !readOnly ? patient.id : null,
          readOnly,
        },
        isMoreMenuOpen: null,
      });
    } catch (err) {
      notification.error({
        message: `error`,
        description: err.error.message,
        top: '100px',
      });
    }
  };

  handleClickOpenDialogManageDevice = async (patient) => {
    try {
      await this.initDataPatient(patient);
      this.props.patient.clearSelectDevice();
      this.props.deviceType.setAction('category', null);
      await this.props.deviceType.getCategory();
      // let devices = await this.props.dashboard.getDeviceList();
      // let devicesFilter = devices.filter((device) => {
      //   return !device.patientId;
      // });
      // this.props.patient.setDeviceList(devicesFilter);
      this.setState({
        dialogDevice: { open: true, id: patient.id },
        isMoreMenuOpen: null,
      });
    } catch (err) {
      if (err.statusCode === 401) {
        this.signOut();
        window.location.replace('/login');
      } else {
        notification.error({
          message: `error`,
          description: err.error.message,
          top: '100px',
        });
      }
    }
  };

  handleClickOpenDialogAlertSetting = async (patient) => {
    try {
      await this.props.area.getAreas(0, 0, null, null, null, patient && patient.tenantId ? [patient.tenantId] : null);
      await this.props.settingProfile.getSettingProfile(0, 0);
      await this.props.setting.getSettingByPatient(patient.id);
      this.setState({
        dialogSetting: { open: true, id: patient.id },
        isMoreMenuOpen: null,
      });
    } catch (err) {
      if (err.statusCode === 401) {
        this.signOut();
        window.location.replace('/login');
      } else {
        notification.error({
          message: `error`,
          description: err.error.message,
          top: '100px',
        });
      }
    }
  };

  handleClickOpenDialogManageGarminAccount = async (patient) => {
    try {
      const queryOption = {
        patient: true,
        device: true,
        tenantIds: patient && patient.tenantId ? JSON.stringify([patient.tenantId]) : null,
      };
      await this.props.smartwatch.getAllAccounts(queryOption);
      await this.props.smartwatch.getAccountByPatientId(patient.id);
      this.setState({
        dialogGarminAccount: { open: true, id: patient.id },
        isMoreMenuOpen: null,
      });
    } catch (err) {
      if (err.statusCode === 401) {
        this.signOut();
        window.location.replace('/login');
      } else {
        notification.error({
          message: `error`,
          description: err.error.message,
          top: '100px',
        });
      }
    }
  };

  handleClickDischagePatient = async (patient) => {
    const { t } = this.props;
    const name = fullname(localStorage.getItem('i18nextLng'), patient);
    Swal.fire({
      html:
        patient.devices.length > 0
          ? `<h4>${t('device_assigned_to')} "${name}"<h4>${t('discharge_patient2')}`
          : `<h4>${t('sure_to_discharge')}`,
      type: 'warning',
      confirmButtonText: `${t('discharge')}`,
      cancelButtonText: `${t('close')}`,
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        this.setState({ isMoreMenuOpen: null });
        try {
          const bed = await this.props.dashboard.getBedByPatient(patient.id);
          if (patient.devices.length > 0) {
            for (const data of patient.devices) {
              await this.props.device.unAssignDeviceToPatient(data.id, data.serial);
              // this.clearAlert(data.serial);
            }
            this.clearAlert(bed);
            // patient.devices.forEach(async (data) => {
            //   await this.props.device.unAssignDeviceToPatient(
            //     data.id,
            //     data.serial
            //   );
            //   this.clearAlert(data.serial);
            // });
          }
          await this.props.dashboard.discharge(bed, true);

          // automatically delete bed if module type is 'home'
          if ((localStorage.getItem('subgroup_type') || 'hospital') === 'home') {
            await this.props.dashboard.deleteBedPermanently(bed.id);
            await this.props.dashboard.getPatientForSubgroup(localStorage.getItem('select_module'), false);
          }
        } catch (err) {
          if (err.statusCode === 401) {
            this.signOut();
            window.location.replace('/login');
          } else {
            notification.error({
              message: `error`,
              description: err.error.message,
              top: '100px',
            });
          }
        }
      }
    });
  };

  handleClickOpenDialogCreateAccount = async (patient) => {
    await this.props.user.getUserPatient(patient && patient.id);
    this.setState({
      dialogCreateAccount: {
        open: true,
        id: patient && patient.id ? patient.id : null,
      },
      isMoreMenuOpen: null,
    });
  };

  handleClickMovement = async (patient) => {
    await this.initDataPatient(patient);
    this.setState({
      dialogMovement: { open: true, id: patient.id },
      isMoreMenuOpen: null,
    });
  };

  handleClickOpenDialogVitalSigns = async (patient) => {
    this.setState({
      patientData: patient,
      dialogVitalSigns: {
        open: true,
        id: patient.id,
      },
    });
  };

  // Search HN //
  handleSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  handleChangeSearch = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleChangeSearchHN =
    (name) =>
    (event, { newValue }) => {
      this.setState({
        [name]: newValue,
      });
    };
  // End Search HN //

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  filterByValue = (language, data, inputValue, fieldName) => {
    let value = false;
    if (language === 'th-TH') {
      if (data && data.firstname && fieldName === 'firstname') {
        value = data.firstname.toLowerCase().includes(inputValue);
      }
      if (data && data.lastname && fieldName === 'lastname') {
        value = data.lastname.toLowerCase().includes(inputValue);
      }
    }
    if (language === 'en-EN') {
      if (data && data.firstnameEn && fieldName === 'firstname') {
        value = data.firstnameEn.toLowerCase().includes(inputValue);
      }
      if (data && data.lastnameEn && fieldName === 'lastname') {
        value = data.lastnameEn.toLowerCase().includes(inputValue);
      }
    }
    return value;
  };

  isMuted = (userWithAlert) => {
    let muteNotification = localStorage.getItem('mute_notification');
    muteNotification = muteNotification ? JSON.parse(muteNotification) : [];
    const mutePatient = muteNotification.find((val) => val.patientId === userWithAlert.patientId);
    if (mutePatient) {
      if (
        userWithAlert &&
        userWithAlert.patient &&
        userWithAlert.patient.devices &&
        userWithAlert.patient.devices.length > 0
      ) {
        const alertIds = [];
        userWithAlert.patient.devices.forEach((d) => {
          if (d.action && d.action.alerts.length > 0) {
            d.action.alerts.forEach((a) => {
              if (a.alertId && a.alertType !== 513) {
                alertIds.push(a.alertId);
              }
            });
          }
        });
        const newAlertIds = alertIds.filter((x) => !(mutePatient.alertId || []).includes(x));
        return newAlertIds.length === 0 ? true : false;
      }
    }
    return false;
  };

  hasReport(devices, reportType) {
    const found = devices.filter((d) => {
      if (!d.deviceVersion) {
        return false;
      }
      const deviceProperty = d.deviceVersion['property'] ? JSON.parse(d.deviceVersion['property']) : null;
      if (deviceProperty) {
        return deviceProperty[reportType] === 1;
      }

      return false;
    });
    return found.length > 0;
  }

  getCurrentAssignedDevice = (devices) => {
    return {
      assignedDevices: devices && devices.length > 0 ? devices.map((v) => v.name) : [],
      reportOptions: {
        hasActivity: devices && devices.length > 0 ? this.hasReport(devices, 'motionTracker') : true,
        hasLocalization: devices && devices.length > 0 ? this.hasReport(devices, 'localization') : true,
      },
    };
  };

  handleDisplayFixedEmergency = () => {
    this.setState({
      isDisplayFixedEmergency: !this.state.isDisplayFixedEmergency,
    });
  };

  render() {
    const { classes, t } = this.props;
    let { routerNoSignal } = this.props.dashboard.toJS();
    let dashboard = this.props.dashboard.toJS();
    const patient = this.props.patient.toJS();
    const setting = this.props.setting.toJS();
    let subGroup = this.props.subGroup.toJS();
    const group = this.props.group.toJS();
    // const maps = this.props.maps.toJS();
    const router = this.props.router.toJS();
    const { page, seeFunc, patientData } = this.state;
    const showActivateButton =
      patientData &&
      patientData.devices &&
      patientData.devices
        .map((value) => (value.deviceVersion ? JSON.parse(value.deviceVersion.property).activateButton : 0))
        .some((value) => value);

    const showAlertSetting = patientData && patientData.devices && patientData.devices.length > 0;
    const { activeFullScreen } = this.props.screen.toJS();
    let styleFullScreen = activeFullScreen ? { display: 'none' } : { display: 'flex' };

    let groupsList = group.groups;
    let subList = subGroup.ListSubGroups;

    if (localStorage.getItem('role_id') !== '1') {
      const groupPermission = localStorage.getItem('group_permission')
        ? JSON.parse(localStorage.getItem('group_permission'))
        : null;
      groupsList = groupPermission ? (group.groups || []).filter((g) => groupPermission.includes(g.id)) : [];

      const subgroupPermission = localStorage.getItem('subgroup_permission')
        ? JSON.parse(localStorage.getItem('subgroup_permission'))
        : null;
      const allSubgroupIds = subGroup.ListSubGroups.map((s) => s.id);
      const diff = allSubgroupIds.filter((id) => !(subgroupPermission || []).includes(id));
      if (diff.length === allSubgroupIds.length) {
        subList = subGroup.ListSubGroups;
      } else {
        subList = subGroup.ListSubGroups.filter((s) => {
          const found = (subgroupPermission || []).find((f) => f === s.id);
          return found ? true : false;
        });
      }
    }

    // sort groups //
    groupsList.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));

    let subgroupAll = [];
    subList.forEach((val) => {
      subgroupAll.push(val.id);
    });

    // sort module //
    subList.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
    subgroupAll.sort((a, b) => a - b);
    subgroupAll = JSON.stringify(subgroupAll);

    /// Sort room bad and patient ///
    if (localStorage.getItem('last_view') === 'listmanage') {
      dashboard.user = sortListmanage(
        dashboard.user,
        localStorage.getItem('subgroup_type') === 'hospital',
        localStorage.getItem('i18nextLng'),
      );
    } else if (localStorage.getItem('sort') === 'admitted') {
      dashboard.user = sortByAdmited(dashboard.user, localStorage.getItem('i18nextLng'));
    } else if (localStorage.getItem('sort') === 'priority-old') {
      dashboard.user = sortByPriorityOld(dashboard.user, localStorage.getItem('i18nextLng'));
    } else if (localStorage.getItem('sort') === 'priority-new') {
      dashboard.user = sortByPriorityNew(dashboard.user, localStorage.getItem('i18nextLng'));
    } else {
      dashboard.user = sortByRoom(dashboard.user);
    }
    /// End Sort room bad and patient ///

    // const AlertCritical = dashboard.user.find(
    //   (val) =>
    //     val.patient &&
    //     val.patient.devices &&
    //     hasAlertType(val.patient.devices, "alertCritical") &&
    //     !this.isMuted(val)
    // );

    // sound //
    const AlertCritical =
      dashboard.fixedEmergency.length > 0
        ? true
        : dashboard.user.find(
            (val) =>
              val.patient &&
              val.patient.devices &&
              hasAlertType(val.patient.devices, 'alertCritical') &&
              !this.isMuted(val),
          );

    const AlertWarning = !AlertCritical
      ? dashboard.user.find(
          (val) =>
            val.patient &&
            val.patient.devices &&
            hasAlertType(val.patient.devices, 'alertWarning') &&
            !this.isMuted(val),
        )
      : null;

    // Search HN //
    if (this.state.searchHN) {
      const inputValue = deburr(this.state.searchHN.trim()).toLowerCase();
      // const inputLength = this.state.searchHN.length;
      dashboard.user = dashboard.user.filter((val) => {
        if (val && val.patient) {
          if (
            (val.patient.hn && val.patient.hn.toLowerCase().includes(inputValue)) ||
            this.filterByValue(localStorage.getItem('i18nextLng'), val.patient, inputValue, 'firstname') ||
            this.filterByValue(localStorage.getItem('i18nextLng'), val.patient, inputValue, 'lastname') ||
            (val.roomName && val.roomName.toLowerCase().includes(inputValue)) ||
            (val.name && val.name.toLowerCase().includes(inputValue))
          ) {
            return true;
          }
        } else if (val && !val.patient) {
          if (
            (val.roomName && val.roomName.toLowerCase().includes(inputValue)) ||
            (val.name && val.name.toLowerCase().includes(inputValue))
          ) {
            return true;
          }
        }
        return false;
      });
    }
    // End Search HN //

    const findPatientDevice = (dashboard.user || []).find((item) => item.patientId === this.state.dialogDevice.id);
    const findPatientSetting = (dashboard.user || []).find((item) => item.patientId === this.state.dialogSetting.id);
    const findPatientSummary = (dashboard.user || []).find((item) => item.patientId === this.state.dialogActivities.id);

    const findDataStatue = (dashboard.user || []).find((item) => item.patientId === this.state.dialogStatus.id);

    // const autosuggestProps = {
    //   renderInputComponent: this.renderInputComponent,
    //   suggestions: this.state.suggestions,
    //   onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
    //   onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
    //   getSuggestionValue: this.getSuggestionValue,
    //   renderSuggestion: this.renderSuggestion,
    // };

    // construct dataBed
    let dataBed = null;
    if (this.state.dialogPatient.open) {
      if (this.state.dialogPatient.id) {
        dataBed = (dashboard.user || []).find((item) => item.patientId === this.state.dialogPatient.id);
      } else if (this.state.dialogPatient.bedInfo) {
        dataBed = this.state.dialogPatient.bedInfo;
      }
    } else if (this.state.dialogContact.open) {
      if (this.state.dialogContact.id) {
        dataBed = (dashboard.user || []).find((item) => item.patientId === this.state.dialogContact.id);
      }
    } else if (this.state.dialogMovement.open) {
      if (this.state.dialogMovement.id) {
        dataBed = (dashboard.user || []).find((item) => item.patientId === this.state.dialogMovement.id);
      }
    }

    dashboard.fixedEmergency = sortFixedEmergency(dashboard.fixedEmergency);

    let noOfFixedEmergency = 0;
    const selectSubgroup = localStorage.getItem('select_module');
    if (selectSubgroup) {
      (dashboard.fixedEmergency || []).forEach((e) => {
        if (e.notifications.length > 0) {
          e.notifications.forEach((n) => {
            noOfFixedEmergency += n.alerts.length;
          });
        }
      });
    }

    let tmp = (
      <Fragment>
        <Loader
          loading={
            dashboard.loading ||
            setting.loading ||
            patient.loading ||
            // event.loading ||
            subGroup.loading
            // group.loading
          }
        />
        <Sound
          position={1}
          url={soundCritical}
          playStatus={this.state.soundEmergincy ? Sound.status.PLAYING : Sound.status.STOPPED}
          loop={true}
        />
        <Sound
          position={1}
          url={soundCritical}
          playStatus={AlertCritical ? Sound.status.PLAYING : Sound.status.STOPPED}
          loop={true}
        />
        <Sound
          position={2}
          url={soundWarning}
          playStatus={AlertWarning ? Sound.status.PLAYING : Sound.status.STOPPED}
          loop={true}
          autoLoad={true}
        />
        <Alert contentTemplate={CustomContentTemplate} stack={false} />
        {this.state.dialogActivities.open && (
          // <Activities
          //   patientId={findPatientSummary.patient.id}
          //   firstname={findPatientSummary.patient.firstname}
          //   lastname={findPatientSummary.patient.lastname}
          //   firstnameEn={findPatientSummary.patient.firstnameEn}
          //   lastnameEn={findPatientSummary.patient.lastnameEn}
          //   devices={findPatientSummary.patient.devices}
          //   open={this.state.dialogActivities.open}
          //   handleClose={this.handleCloseDialog}
          // />
          <SummaryReportPage
            open={this.state.dialogActivities.open}
            handleClose={this.handleCloseDialog}
            data={findPatientSummary}
            isEmergency={this.isEmergencyButton(findPatientSummary.patient.devices)}
            currentAssignedDevice={this.getCurrentAssignedDevice(findPatientSummary.patient.devices)}
            // alertType={alertType}
          />
        )}
        {this.state.dialogSetting.open && (
          <Setting
            props={this.props}
            patientData={findPatientSetting.patient}
            state={this.state}
            // dataList={dataList}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogDevice.open && (
          <Devices
            // props={this.props}
            patientData={findPatientDevice}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogPatient.open && (
          <Patient props={this.props} dataBed={dataBed} state={this.state} handleClose={this.handleCloseDialog} />
        )}
        {this.state.dialogContact.open && (
          <ContactPerson
            props={this.props}
            patient={dataBed.patient}
            readOnly={this.state.dialogContact.readOnly}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogMovement.open && (
          <Movement
            props={this.props}
            dataBed={dataBed}
            patientData={this.state.patientData}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogCreateAccount.open && (
          <CreateAccount
            props={this.props}
            patientData={this.state.patientData}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogStatus.open && (
          <StatusView open={this.state.dialogStatus.open} data={findDataStatue} setCloseStatus={this.setCloseStatus} />
        )}
        {this.state.dialogGarminAccount.open && (
          <ManageGarminAccount
            open={this.state.dialogGarminAccount.open}
            patientData={this.state.patientData}
            handleClose={this.handleCloseDialog}
            pathName={this.props.location.pathname}
          />
        )}
        {this.state.dialogVitalSigns.open && (
          <VitalSigns
            patientData={this.state.patientData}
            open={this.state.dialogVitalSigns.open}
            handleClose={this.handleCloseDialog}
            date={getCurrentDateBuddhistFormatted(new Date())}
            time={moment(new Date()).format('HH:mm')}
          />
        )}
        <Grid container alignItems='flex-start'>
          <HeaderBar
            seeFunc={seeFunc}
            page={page}
            router={router}
            gridPage={this.state.gridPage}
            routerNoSignal={routerNoSignal}
            styleFullScreen={styleFullScreen}
            groupsList={groupsList}
            group={this.state.group}
            subList={subList}
            subgroupAll={subgroupAll}
            module={this.state.module}
            searchHN={this.state.searchHN}
            sort={this.state.sort}
            anchorEl={this.state.anchorEl}
            handleChange={this.handleChange}
            handleChangeSearch={this.handleChangeSearch}
            handleChangeSort={this.handleChangeSort}
            handleChangePage={this.handleChangePage}
            handleClickList={this.handleClickList}
            handleClickMobile={this.handleClickMobile}
            handleClick={this.handleClick}
            handleClose={this.handleClose}
            handleChangeGrid={this.handleChangeGrid}
          />

          {/* ----- start gridview phase ----- */}
          {page === 0 && (
            <Grid container alignItems='flex-start' className={classes.content}>
              <Grid
                container
                item
                md={localStorage.getItem('role_id') === '1' && this.props.logActivity.display === true ? 9 : 12}
                xs={12}
                id='main-container'
              >
                {dashboard.user.length > 0 && this.getContent(dashboard.user)}
              </Grid>
              {/* {localStorage.getItem("role_id") === '1' &&
                <Grid container item md={3} xs={12} style={{ display: this.props.logActivity.display === true ? '' : 'none' }}>
                  <PatientActivity />
                </Grid>
              } */}
            </Grid>
          )}
          {/* ----- end gridview phase ----- */}

          {/* ----- start listview phase ----- */}
          {page === 1 &&
            seeFunc.seeList &&
            localStorage.getItem('select_group') &&
            localStorage.getItem('select_module') && (
              <Fragment>
                {(localStorage.getItem('subgroup_type') || 'hospital') === 'home' && (
                  <Button
                    fullWidth
                    variant='outlined'
                    className={classes.activeAddPatientButton}
                    onClick={this.handleClickOpenDialogAddPatient.bind(this, null)}
                  >
                    <Icons.PersonAdd />
                    {t('admit_patient')}
                  </Button>
                )}
                <Grid container className={classes.mainContainList}>
                  <Grid item xs={12}>
                    {dashboard.user.length > 0 && this.getColumn(dashboard.user)}
                  </Grid>
                </Grid>
              </Fragment>
            )}
          {/* ----- end listview phase ----- */}

          {/* ----- start map phase ----- */}
          {page === 2 && seeFunc.seeMap && (
            <Fragment>
              <Grid container spacing={16} item md={12} xs={12}>
                <Map fixedEmergencyAlert={dashboard.fixedEmergency} />
              </Grid>
            </Fragment>
          )}
          {/* ----- end map phase ----- */}

          {this.state.patientData && this.state.patientData.id && (
            <Menu
              id='more-menu'
              open={Boolean(this.state.isMoreMenuOpen)}
              anchorEl={this.state.isMoreMenuOpen}
              onClose={this.setMoreMenuClose}
              disableAutoFocusItem
            >
              {showActivateButton && (
                <div>
                  <MenuItem onClick={() => this.chageActivate(this.state.patientData)}>
                    <Typography>
                      {(this.state.patientData.devices.length > 0 && this.state.patientData.devices[0].status) ===
                      'ACTIVATE_ON'
                        ? t('off')
                        : t('on')}
                    </Typography>
                  </MenuItem>
                  <hr className={classes.dialogMenu} />
                </div>
              )}

              <MenuItem onClick={() => this.handleClickOpenDialogManageDevice(this.state.patientData)}>
                <Typography>{t('manage_devices')}</Typography>
              </MenuItem>

              <MenuItem
                onClick={() => this.handleClickOpenDialogAlertSetting(this.state.patientData)}
                disabled={showAlertSetting ? false : true}
              >
                <Typography>{t('alert_setting')}</Typography>
              </MenuItem>
              <hr className={classes.dialogMenu} />

              {config.features.report.garmin && (
                <MenuItem onClick={() => this.handleClickOpenDialogManageGarminAccount(this.state.patientData)}>
                  <Typography>{t('manage_garmin_account')}</Typography>
                </MenuItem>
              )}
              <MenuItem onClick={() => this.handleClickOpenDialogCreateAccount(this.state.patientData)}>
                <Typography>{t('manage_myactsense_account')}</Typography>
              </MenuItem>
              <hr className={classes.dialogMenu} />

              <MenuItem
                onClick={() => this.handleClickOpenDialogEditPatient(this.state.patientData)}
                // disabled={config.features.allPatients.syncNirun}
              >
                <Typography>{t('edit_patient')}</Typography>
              </MenuItem>

              <MenuItem
                onClick={() => this.handleClickOpenDialogContact(this.state.patientData)}
                // disabled={config.features.allPatients.syncNirun}
              >
                <Typography>{t('edit_contact_info')}</Typography>
              </MenuItem>

              <MenuItem
                className={classes.displayVitalsign}
                onClick={() => this.handleClickOpenDialogVitalSigns(this.state.patientData)}
              >
                <Typography>{t('vitalsign')}</Typography>
              </MenuItem>

              <MenuItem onClick={() => this.handleClickMovement(this.state.patientData)}>
                <Typography>{t('move_patient')}</Typography>
              </MenuItem>
              <MenuItem onClick={() => this.handleClickDischagePatient(this.state.patientData)}>
                <Typography>{t('discharge')}</Typography>
              </MenuItem>
              <hr className={classes.dialogMenu} />

              <MenuItem onClick={() => this.handleClickOpenDialogActivities(this.state.patientData)}>
                <Typography>{t('summary_report')}</Typography>
              </MenuItem>
            </Menu>
          )}

          {/* ----- fixed emergency phase ----- */}
          <Grid className={classes.fixedAlertPosition} style={{ display: noOfFixedEmergency ? '' : 'none' }}>
            {!this.state.isDisplayFixedEmergency && <div className={classes.fixedAlertMockPosition} />}
            {this.state.isDisplayFixedEmergency && (
              <Paper className={classes.fixedAlertBox}>
                <div className={classes.widgetHeader}>
                  <AppBar position='static' className={classes.headerToolbar}>
                    <Grid container>
                      <div className={classes.titleHeader}>{t('location_based_alert')}</div>
                      <div className={classes.iconMinimize} onClick={this.handleDisplayFixedEmergency}>
                        <svg width='18' height='18' viewBox='0 0 18 18'>
                          <use xlinkHref={`/images/menus-v1.svg#minimize`} />
                        </svg>
                      </div>
                    </Grid>
                  </AppBar>
                </div>
                <div className={classes.fixedAlertContent}>
                  {dashboard.fixedEmergency &&
                    dashboard.fixedEmergency.length > 0 &&
                    dashboard.fixedEmergency.map((e) => (
                      <div key={e.date}>
                        <div style={{ fontSize: 14, fontWeight: 400 }}>{fixedEmergencyDate(e.date, t)}</div>
                        <hr className={classes.dividers} />
                        {(e.notifications || []).map((noti, i) =>
                          (noti.alerts || []).map((a) => (
                            <Grid container key={i} style={{ marginBottom: 10, marginTop: 10 }}>
                              <Grid container item sm={10}>
                                <div style={{ width: '15%' }}>
                                  <svg width='28' height='28' viewBox='0 0 84 83'>
                                    <use xlinkHref={`/images/sos-v4.svg#fixed`} />
                                  </svg>
                                </div>
                                <div className={classes.fixedAlertTime}>{moment(a.alertTime).format('HH:mm')}</div>
                                <div className={classes.alertPlace}>{a.alertFixedEmergencyPlace}</div>
                              </Grid>
                              <Grid container item sm={2} style={{ justifyContent: 'right' }}>
                                <IconButton
                                  classes={{ root: classes.btnAck }}
                                  aria-label='delete'
                                  id='acknowledge'
                                  onClick={() => this.acknowledgeFixedEmegency(noti)}
                                >
                                  <svg
                                    width='21'
                                    height='21'
                                    viewBox='0 0 21 21'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                    className={classes.btnAckCritical}
                                  >
                                    <path d='M6.5 11L9 14L15.5 6' strokeWidth='1.5' />
                                  </svg>
                                </IconButton>
                              </Grid>
                            </Grid>
                          )),
                        )}
                      </div>
                    ))}
                </div>
              </Paper>
            )}
            <IconButton className={classes.buttonFixedEmergency} onClick={this.handleDisplayFixedEmergency}>
              <svg width='60' height='60' viewBox='0 0 84 83'>
                <use xlinkHref={`/images/sos-v4.svg#fixed`} />
              </svg>
              <label
                className='badge badge-primary-sos'
                style={{
                  display: noOfFixedEmergency ? '' : 'none',
                }}
              >
                {noOfFixedEmergency}
              </label>
            </IconButton>
          </Grid>
        </Grid>
      </Fragment>
    );
    return tmp;
  }
}

const styles = (theme) => ({
  container: {
    position: 'relative',
    margin: '8px',
    '& label': {
      color: 'rgb(0, 150, 135)',
      fontSize: '1.4rem',
    },
    '& fieldset': {
      top: '4px',
      // borderColor: "#009688 !important",
    },
  },
  suggestionsContainer: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  input: {
    paddingBottom: '7px',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  moreButton: {
    // margin: -theme.spacing.unit,
    padding: 0,
    width: 26,
    height: 26,
    margin: 2,
    color: theme.palette.success.main,
    backgroundColor: theme.palette.primary.bg,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
  iconColor: {
    color: theme.palette.success.main,
    marginRight: 5,
  },
  mainContainList: {
    width: '100%',
    padding: '15px 19px 0px 17px',
    // margin: "7px 15px",
  },
  paperList: {
    overflowX: 'auto',
    padding: '10px 20px',
  },
  headTable: {
    border: 'none',
    height: 40,
  },
  textLabel: {
    color: theme.palette.success.main,
    fontSize: '1.4rem',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit / 2,
    width: `calc(100vw - 240px)`,
    minHeight: '100vh',
  },
  paper: {
    width: '100%',
    overflowY: 'auto',
    height: '90vh',
    position: 'relative',
  },
  tableBody: {
    position: 'absolute',
    marginTop: '46px',
    padding: theme.spacing.unit * 1,
  },
  boxContent: {
    padding: '5px',
  },
  boxContentGrid: {
    // [theme.breakpoints.down("md")]: {
    //   display: 'none',
    // },
    padding: '5px',
  },
  boxPadding: {
    paddingTop: '8px',
  },
  // table: {
  //   overflowX: 'auto'
  // },
  warningBox: {
    position: 'fixed',
    width: '25%',
    height: '70%',
    backgroundColor: 'white',
    bottom: '10px',
    right: '2px',
  },
  titleFilter: {
    display: 'flex',
    marginBottom: '32px',
  },
  title: {
    display: 'flex',
    marginTop: '40px',
    marginBottom: '32px',
  },
  inline: {
    display: 'inline',
    marginLeft: '5px',
  },
  iconWarning: {
    color: 'rgb(255, 194, 96)',
  },
  card: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  visitsNumberContainer: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    //paddingBottom: theme.spacing.unit * 1,
  },
  progressSection: {
    marginBottom: theme.spacing.unit,
  },
  progressTitle: {
    marginBottom: theme.spacing.unit * 1,
  },
  progress: {
    marginBottom: theme.spacing.unit,
    backgroundColor: theme.palette.primary.main,
  },
  pieChartLegendWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginRight: theme.spacing.unit,
  },
  legendItemContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  fullHeightBody: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  tableWidget: {
    overflowX: 'auto',
  },
  progressBar: {
    backgroundColor: theme.palette.warning.main,
  },
  performanceLegendWrapper: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  legendElement: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing.unit * 2,
  },
  legendElementText: {
    marginLeft: theme.spacing.unit,
  },
  serverOverviewElement: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
  },
  serverOverviewElementText: {
    minWidth: 145,
    paddingRight: theme.spacing.unit * 2,
  },
  serverOverviewElementChartWrapper: {
    width: '100%',
  },
  mainChartHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.only('xs')]: {
      flexWrap: 'wrap',
    },
  },
  mainChartHeaderLabels: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.only('xs')]: {
      order: 3,
      width: '100%',
      justifyContent: 'center',
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
  },
  mainChartHeaderLabel: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing.unit * 3,
  },
  mainChartSelectRoot: {
    borderColor: theme.palette.text.hint + '80 !important',
  },
  mainChartSelect: {
    padding: 10,
    paddingRight: 25,
  },
  mainChartLegentElement: {
    fontSize: '18px !important',
    marginLeft: theme.spacing.unit,
  },
  materialIconText: {
    marginLeft: theme.spacing.unit,
    fontSize: '16px',
    fontWeight: 500,
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit,
    minWidth: 100,
    maxWidth: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  reactDatepickerPopper: {
    zIndex: '9999 !important',
  },
  texthover: {
    '& .MuiTooltip-tooltip': {
      color: 'white',
    },
  },
  hiddenText: {
    [theme.breakpoints.down('lg')]: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: 150,
    },
  },
  activityBox: {
    boxShadow: 'none',
  },
  iconActivity: {
    color: 'black',
  },
  customizeBoxIcon: {
    paddingLeft: '5px',
    minHeight: '38px',
    marginBottom: '-5px',
    paddingBottom: theme.spacing.unit * 1,
  },
  tabBar: {
    background: 'white',
    paddingRight: theme.spacing.unit * 1,
    paddingLeft: theme.spacing.unit * 1,
    boxShadow: '0px 0px 0px 0px rgba(0,0,0,0), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0)',
  },
  positionView: {
    // justifyContent: 'flex-end',
    [theme.breakpoints.only('sm')]: {
      justifyContent: 'flex-end',
    },
    paddingTop: '4px',
  },
  buttonOption: {
    padding: '3px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  buttons: {
    display: 'flex',
  },
  button: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    height: '30px',
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
      color: 'white',
    },
  },
  activeButton: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    height: '40px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },

  buttonMap: {
    height: '40px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },
  activeButtonMap: {
    height: '40px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },
  addPatientButton: {
    height: '40px',
    width: '160px',
    marginTop: '10px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },

  activeAddPatientButton: {
    height: '40px',
    width: '160px',
    marginTop: '10px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },

  buttonMobile: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    height: '40px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },
  activeButtonMobile: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    height: '40px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },
  buttonFixedEmergency: {
    top: 50,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  gridMenu: {
    marginTop: theme.spacing.unit * 7,
  },
  sortMenu: {
    // minWidth: 110,
    width: '110px',
  },
  Contentselect: {
    '& fieldset': {
      // borderColor: `${theme.palette.primary.main} !important`,
      borderWidth: '2px',
      top: '4px',
    },
    '& svg': {
      top: 'calc(50% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  actionBox: {
    minWidth: '280px',
  },
  icongender: {
    fontSize: '16px',
    marginRight: theme.spacing.unit * 2,
    color: theme.palette.primary.main,
  },
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  appBar: {
    position: 'relative',
  },
  contentTitle: {
    float: 'left',
    color: 'white',
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
  formSelect: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit,
    minWidth: 130,
    maxWidth: '100%',
  },
  selectOption: {
    '& fieldset': {
      top: '-2px',
      bottom: '2px',
    },
    '& svg': {
      top: 'calc(50% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '5px',
    },
    '&:hover, &:focus': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },
  widgetWrapper: {
    display: 'flex',
    // minHeight: '100%',
    minHeight: '180px',
  },
  widgetHeader: {
    paddingBottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  widgetRoot: {
    boxShadow: theme.customShadows.widget,
  },
  widgetBody: {
    padding: theme.spacing.unit * 0.5,
  },
  headerToolbar: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: theme.palette.error.main,
    boxShadow: 'none',
    height: 37,
    padding: '7px 17px',
  },
  titleHeader: {
    width: '90%',
    fontSize: '16px',
    fontWeight: 600,
    color: 'white',
  },
  iconMinimize: {
    width: '10%',
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    cursor: 'pointer',
  },
  btnAck: {
    padding: 0,
    width: 28,
    height: 28,
    color: theme.palette.error.main,
    cursor: 'pointer',
    backgroundColor: 'rgba(235, 88, 97, 0.4)',
    '&:hover': {
      backgroundColor: 'rgba(235, 88, 97, 0.4)',
    },
  },
  btnAckCritical: {
    width: 22,
    stroke: theme.palette.error.main,
  },
  noPadding: {
    padding: 0,
  },
  '@keyframes blinker-critical': {
    '50%': {
      borderStyle: 'solid',
      borderColor: 'rgb(176, 0, 32)',
      borderWidth: '2.0px',
    },
  },
  '@keyframes blinker-warning': {
    '50%': {
      borderStyle: 'solid',
      borderColor: 'rgb(255, 255, 255)',
      borderWidth: '2.0px',
    },
  },
  '@keyframes blinker-info': {
    '50%': {
      borderStyle: 'solid',
      borderColor: 'rgb(255, 255, 255)',
      borderWidth: '2.0px',
    },
  },
  paperCritical: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
    borderRadius: '10px',
    borderStyle: 'solid',
    borderColor: 'white',
    borderWidth: '2.0px',
    animationName: 'blinker-critical',
    animationDuration: '0.5s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
  paperWarning: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
    borderRadius: '10px',
    borderStyle: 'solid',
    borderColor: '#F1C40F',
    borderWidth: '2.0px',
    // animationName: 'blinker-warning',
    // animationDuration: '0.5s',
    // animationTimingFunction: 'linear',
    // animationIterationCount: 'infinite',
  },
  paperInfo: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
    borderRadius: '10px',
    borderStyle: 'solid',
    borderColor: '#4ebdff',
    borderWidth: '2.0px',
  },
  customizeToolbar: {
    minHeight: '27px',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
  footer: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: 'white',
    boxShadow: 'none',
  },
  footerCritical: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: 'rgb(176, 0, 32)',
    // color: 'white'
  },
  footerWarning: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: '#F1C40F',
  },
  footerInfo: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: '#4ebdff',
  },
  buttonBox: {
    display: 'flex',
    position: 'absolute',
    right: 5,
  },
  buttonVitalSign: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 2,
    position: 'absolute',
    right: 5,
    color: theme.palette.success.main,
    backgroundColor: theme.palette.primary.bg,
    width: 22,
    height: 22,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
  formInput: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    '& label': {
      transform: 'translate(0px, 7px) scale(0.7) !important',
      fontSize: '1.33rem !important',
      width: 'max-content',
    },
  },
  textfield: {
    '& fieldset': {
      top: '4px',
      bottom: '6px',
    },
    '& input': {
      marginLeft: '-2px',
    },
    '& label': {
      marginLeft: '2px',
    },
    width: '100%',
    minWidth: 145,
    paddingRight: '12px',
    paddingLeft: '4px',
  },
  textLabelSelect: {
    marginTop: '5px',
  },
  fontAlert: {
    fontSize: '1rem',
  },
  fontgrid: {
    fontSize: '0.7rem',
  },
  noPatient: {
    textAlign: 'center',
    paddingTop: '40px',
    paddingBottom: '26px',
    minHeight: '100px',
  },
  noPatientGrid: {
    textAlign: 'center',
    paddingTop: '43px',
    paddingBottom: '23px',
  },
  chipLabel: {
    display: 'inline',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  addPatient: {
    borderColor: 'rgb(224, 224, 224)',
    color: 'rgb(224, 224, 224)',
  },
  SettingList: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-start',
    textAlign: 'left',
    paddingBottom: 0,
    paddingTop: 0,
  },
  dialogMenu: {
    backgroundColor: 'rgba(9,30,66,0.13)',
    border: 0,
    height: '1px',
    margin: '11px',
    padding: 0,
    width: '84%',
  },
  dividers: {
    backgroundColor: 'rgba(9,30,66,0.13)',
    border: 0,
    height: '1px',
    padding: 0,
    margin: '5px 0px',
    width: '100%',
  },
  RadioGroup: {
    marginTop: '-12px',
  },
  tooltipFont: {
    fontSize: '15px',
  },
  tableCell: {
    color: theme.palette.text.header,
    borderBottom: '1px solid #B8CFC3',
    padding: '4px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  tableCellHiding: {
    color: theme.palette.text.header,
    borderBottom: '1px solid #B8CFC3',
    padding: '4px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  tableCellStatus: {
    color: theme.palette.text.header,
    borderBottom: '1px solid #B8CFC3',
    padding: '10px',
  },
  positionPaper: {
    position: 'relative',
    marginTop: '-10px',
    zIndex: 1400,
  },
  patientMenuItem: {
    width: '100%',
    maxHeight: 200,
    overflow: 'auto',
  },
  fontHeader: {
    color: theme.palette.text.header,
    padding: 10,
    fontSize: 38,
    fontWeight: 500,
  },
  fontText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    padding: 10,
    marginTop: 10,
  },
  fontLink: {
    color: '#4CB6AC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    padding: 10,
    marginTop: 10,
    textDecoration: 'underline',
  },
  btnAdd: {
    padding: 10,
    display: 'flex',
    justifyContent: 'end',
  },
  iconStatus: {
    display: 'flex',
    justifyContent: 'right',
  },
  fixedAlertPosition: {
    display: 'flex',
    position: 'fixed',
    right: '2%',
    bottom: '1%',
    zIndex: 1100,
  },
  fixedAlertMockPosition: {
    height: '155px',
  },
  fixedAlertBox: {
    position: 'relative',
    overflow: 'hidden',
    width: '351px',
    height: '155px',
  },
  fixedAlertContent: {
    padding: '7px 17px 7px 20px',
    position: 'relative',
    overflowY: 'scroll',
    height: '115px',
  },
  displayVitalsign: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  fixedAlertTime: {
    color: theme.palette.success.main,
    fontWeight: 400,
    fontSize: 16,
    width: '20%',
  },
  alertPlace: {
    color: theme.palette.text.header,
    fontWeight: 600,
    fontSize: 16,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '65%',
  },
});

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export const page = inject(
  'dashboard',
  'acknowledge',
  'setting',
  'patient',
  'router',
  'logActivity',
  'subGroup',
  'maps',
  'group',
  'fcm',
  'screen',
  'device',
  'settingProfile',
  'area',
  'summary',
  'vitalsign',
  'deviceType',
  'contactperson',
  'smartwatch',
  'smartwatchsummary',
  'user',
  'patientsummaryalert',
)(observer(Dashboard));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
